unit stfmssystem.main;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Menus, WEBLib.Menus, Vcl.Controls,
  WEBLib.ExtCtrls, WEBLib.WebCtrls, Vcl.Imaging.pngimage, WEBLib.Storage,
  System.DateUtils, XData.Web.Client, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, stfmssystem.login, stfmssystem.connection, share.classes,
  WEBLib.JSON, XData.Web.Connection;

type
  Tfrmmain = class(TForm)
    wmSubsMainMenu: TMainMenu;
    btnFile: TMenuItem;
    btnLogout: TMenuItem;
    webconnect: TXDataWebClient;
    btnCompany: TMenuItem;
    btnCompanySettings: TMenuItem;
    btnCompanyTransactions: TMenuItem;
    VehicleAsset1: TMenuItem;
    Employees1: TMenuItem;
    btnSuppliers: TMenuItem;
    Customers1: TMenuItem;
    LoadSystem1: TMenuItem;
    btnFuelSystem: TMenuItem;
    Setup1: TMenuItem;
    btnFuelSystemTransactions: TMenuItem;
    Reports1: TMenuItem;
    Depots1: TMenuItem;
    btnFuelOrders: TMenuItem;
    btnSupplierSetup: TMenuItem;
    btnSubContractorPortal: TMenuItem;
    qUser: TXDataWebDataSet;
    btnUserAccess: TMenuItem;
    Planning1: TMenuItem;
    Settings1: TMenuItem;
    Budgets1: TMenuItem;
    mdMain: TMessageDlg;
    Company1: TMenuItem;
    SMSNumbers1: TMenuItem;
    SMSNumbers2: TMenuItem;
    Costinggroups1: TMenuItem;
    Costinggroups2: TMenuItem;
    EMailNotifications1: TMenuItem;
    FinancialPeriod: TMenuItem;
    SagePastelExport1: TMenuItem;
    SagePastelExport2: TMenuItem;
    SubsUserAccess1: TMenuItem;
    BankReconciliation1: TMenuItem;
    ransactions1: TMenuItem;
    Reports2: TMenuItem;
    VehicleGroup1: TMenuItem;
    VehicleCatagories1: TMenuItem;
    AxleMassSetup1: TMenuItem;
    VehicleUnitSetup1: TMenuItem;
    CombinationSetup1: TMenuItem;
    VehicleServiceHistory1: TMenuItem;
    VehicleServiceHistory2: TMenuItem;
    VehicleMovement1: TMenuItem;
    VehicleMovement2: TMenuItem;
    ShiftChange1: TMenuItem;
    LicenseCOFPermitExpiryDates1: TMenuItem;
    LicenseCOFPermitExpiryDates2: TMenuItem;
    DailyCheckList1: TMenuItem;
    DailyCheckList2: TMenuItem;
    ExportFleetList1: TMenuItem;
    Settings2: TMenuItem;
    ransactions2: TMenuItem;
    ransactions3: TMenuItem;
    EmployeeInformation1: TMenuItem;
    EmployeeInformation2: TMenuItem;
    SetupPublicHoliday1: TMenuItem;
    SetupYearsweetDays1: TMenuItem;
    CommisionTotalValueSetup1: TMenuItem;
    EmployeePlanning1: TMenuItem;
    EmployeePlanning2: TMenuItem;
    Counselling1: TMenuItem;
    Counselling2: TMenuItem;
    PPEIsue1: TMenuItem;
    PPEIsue2: TMenuItem;
    EmployeeDailyCheckList1: TMenuItem;
    ActivityLog1: TMenuItem;
    ExpiryDates1: TMenuItem;
    ExpiryDates2: TMenuItem;
    Medical1: TMenuItem;
    PDrP1: TMenuItem;
    PDrP2: TMenuItem;
    Workspermit1: TMenuItem;
    Workspermit2: TMenuItem;
    raining1: TMenuItem;
    raining2: TMenuItem;
    FatiqueManagement1: TMenuItem;
    FatiqueManagement2: TMenuItem;
    WarningList1: TMenuItem;
    CounselingReport1: TMenuItem;
    CounselingReport2: TMenuItem;
    CommisionReportTotalValue1: TMenuItem;
    CommisionReportTotalValue2: TMenuItem;
    ActivityReport1: TMenuItem;
    ransaction1: TMenuItem;
    Sup1: TMenuItem;
    Portal1: TMenuItem;
    Remittance1: TMenuItem;
    Payments1: TMenuItem;
    Payments2: TMenuItem;
    Payments3: TMenuItem;
    UpfrontDieselReceipt1: TMenuItem;
    UpfrontDieselReceipt2: TMenuItem;
    WriteOffDifferances1: TMenuItem;
    AllocateUnAllocate1: TMenuItem;
    ReverseReceiptPayments1: TMenuItem;
    Settings3: TMenuItem;
    Accounts1: TMenuItem;
    SupplierAgeAnalysis1: TMenuItem;
    Remittances1: TMenuItem;
    DetailLedger1: TMenuItem;
    Settings4: TMenuItem;
    ransactions4: TMenuItem;
    ransactions5: TMenuItem;
    accounts2: TMenuItem;
    CustomerReceipt1: TMenuItem;
    WriteOffDifferences1: TMenuItem;
    WriteOffDifferences2: TMenuItem;
    ReversalReceiptPayments1: TMenuItem;
    CustomerAgeAnalysis1: TMenuItem;
    CustomerAgeAnalysis2: TMenuItem;
    CustomerDetailledger1: TMenuItem;
    Settings5: TMenuItem;
    Settings6: TMenuItem;
    Reports3: TMenuItem;
    FleetInformation1: TMenuItem;
    SetupContracts1: TMenuItem;
    CreateLoadConfirmations1: TMenuItem;
    CreateLoadConfirmations2: TMenuItem;
    ripsheetPlanning1: TMenuItem;
    ripsheetPlanning2: TMenuItem;
    CreateMultiLoadinvoices1: TMenuItem;
    CreateMultiLoadinvoices2: TMenuItem;
    CreateLinkedLoadsInvoices1: TMenuItem;
    CreateLinkedLoadsInvoices2: TMenuItem;
    LoadDebitNotes1: TMenuItem;
    ViewSubContractorInvoices1: TMenuItem;
    ViewSubContractorInvoices2: TMenuItem;
    BatchProgressInvoices1: TMenuItem;
    LoadsReports1: TMenuItem;
    ProfitLoss1: TMenuItem;
    Progress1: TMenuItem;
    Outstanding1: TMenuItem;
    VarrianceControlerProgress1: TMenuItem;
    ControlerProgress1: TMenuItem;
    IncomeReports1: TMenuItem;
    vsFueloncapturedkms1: TMenuItem;
    vsFeuloncalculatedkms1: TMenuItem;
    vsFeuloncalculatedkms2: TMenuItem;
    Driver1: TMenuItem;
    Driver2: TMenuItem;
    Overloading1: TMenuItem;
    Overloading2: TMenuItem;
    Workingday1: TMenuItem;
    Workingday2: TMenuItem;
    Provisions1: TMenuItem;
    Provisions2: TMenuItem;
    LoadsInfoOver12Months1: TMenuItem;
    LoadsInfoOver12Months2: TMenuItem;
    cancelledLoads1: TMenuItem;
    cancelledLoads2: TMenuItem;
    SubContractorEMails1: TMenuItem;
    LoadPlanningSummary: TMenuItem;
    ControllerPlanningProfitLoss1: TMenuItem;
    ControllerPlanningProfitLoss2: TMenuItem;
    FleetInformation2: TMenuItem;
    Attendants1: TMenuItem;
    Attendants2: TMenuItem;
    FuelPriceIncreaseDecrease1: TMenuItem;
    DailyControlSheets1: TMenuItem;
    DailyControlSheets2: TMenuItem;
    BulkPurchaseOrder1: TMenuItem;
    BulkPurchaseOrder2: TMenuItem;
    FuelInvoices1: TMenuItem;
    GetDieselOrdersFromSupplier1: TMenuItem;
    GetDieselOrdersFromSupplier2: TMenuItem;
    FeulDebitNotes1: TMenuItem;
    UpdateInvoicedFuelOrders1: TMenuItem;
    OwnFleetDieselBulkProcess1: TMenuItem;
    CostVsIncomeReports1: TMenuItem;
    DieselDepot1: TMenuItem;
    DieselDepot2: TMenuItem;
    DepotStocklevelreport1: TMenuItem;
    DepotStocklevelreport2: TMenuItem;
    DieselvsKmsreport1: TMenuItem;
    DieselvsKmsreport2: TMenuItem;
    DailyControllSheetsReports1: TMenuItem;
    FuelManSlipInformation1: TMenuItem;
    FuelManSlipInformation2: TMenuItem;
    DriverFeul1: TMenuItem;
    VehicleFuel1: TMenuItem;
    WashbaySystem1: TMenuItem;
    Settings7: TMenuItem;
    Settings8: TMenuItem;
    Reports4: TMenuItem;
    Washbaydepots1: TMenuItem;
    ImportSetup1: TMenuItem;
    ProcessTransactions1: TMenuItem;
    ProcessTransactions2: TMenuItem;
    DebitNote1: TMenuItem;
    DebitNote2: TMenuItem;
    GetWashbayOrderFromSupplier1: TMenuItem;
    Washbayorders1: TMenuItem;
    Washbayorders2: TMenuItem;
    ollSystem1: TMenuItem;
    ollSystem2: TMenuItem;
    Reports5: TMenuItem;
    ollProcessing1: TMenuItem;
    ollsPerVehicle1: TMenuItem;
    ollsPerVehicle2: TMenuItem;
    Settings9: TMenuItem;
    Settings10: TMenuItem;
    Reports6: TMenuItem;
    Warehous1: TMenuItem;
    Warehous2: TMenuItem;
    CostDescription1: TMenuItem;
    CostDescription2: TMenuItem;
    Waranties1: TMenuItem;
    Waranties2: TMenuItem;
    VehicleserviceTypes1: TMenuItem;
    JobCards1: TMenuItem;
    JobCards2: TMenuItem;
    PurchaseRequest1: TMenuItem;
    PurchaseRequest2: TMenuItem;
    PurchaseDelivery1: TMenuItem;
    PurchaseDelivery2: TMenuItem;
    SupplierCreditNotes1: TMenuItem;
    SupplierCreditNotes2: TMenuItem;
    CustomerCreditNotes1: TMenuItem;
    CustomerCreditNotes2: TMenuItem;
    StockTake1: TMenuItem;
    StockTake2: TMenuItem;
    RePrintCreditNote1: TMenuItem;
    Customers2: TMenuItem;
    Customers3: TMenuItem;
    CustomersSuppliers1: TMenuItem;
    Supplier1: TMenuItem;
    StockLedger1: TMenuItem;
    StockLedger2: TMenuItem;
    StockQtyOnHand1: TMenuItem;
    StockQtyOnHand2: TMenuItem;
    StockGoodsReturnNotes1: TMenuItem;
    StockGoodsReturnNotes2: TMenuItem;
    StockQtyOnBackOrder1: TMenuItem;
    StockQtyOnBackOrder2: TMenuItem;
    GeneralLedgerPerCostCenter1: TMenuItem;
    GeneralLedgerPerCostCenter2: TMenuItem;
    MiscellaneousTransactions1: TMenuItem;
    MiscellaneousTransactions2: TMenuItem;
    MiscellaneousCustomerInvoice1: TMenuItem;
    CustomerCreditNote1: TMenuItem;
    CustomerCreditNote2: TMenuItem;
    RePrintCustomerInvoice1: TMenuItem;
    RePrintCustomerInvoice2: TMenuItem;
    RePrintCustomerDebitNote1: TMenuItem;
    RePrintCustomerDebitNote2: TMenuItem;
    SupplierDebitNote1: TMenuItem;
    SupplierDebitNote2: TMenuItem;
    Customer1: TMenuItem;
    Customer2: TMenuItem;
    Customer3: TMenuItem;
    Customer4: TMenuItem;
    Customer5: TMenuItem;
    Customer6: TMenuItem;
    ManagementReports1: TMenuItem;
    ManagementReports2: TMenuItem;
    ransactionJournals1: TMenuItem;
    ransactionJournals2: TMenuItem;
    ProductSalesAnalysis1: TMenuItem;
    ProductSalesAnalysis2: TMenuItem;
    VehicleCostReports1: TMenuItem;
    VehicleCostReports2: TMenuItem;
    N12MonthClientSales1: TMenuItem;
    N12MonthClientSales2: TMenuItem;
    ExportSubsDieselInformation1: TMenuItem;
    ExportSubsDieselInformation2: TMenuItem;
    ransactions6: TMenuItem;
    ransactions7: TMenuItem;
    AIRegister1: TMenuItem;
    ypes1: TMenuItem;
    ypes2: TMenuItem;
    DaysSinceLastTypes1: TMenuItem;
    DaysSinceLastTypes2: TMenuItem;
    CostPerCause1: TMenuItem;
    CostPerCause2: TMenuItem;
    Progressreport1: TMenuItem;
    Progressreport2: TMenuItem;
    AIReports1: TMenuItem;
    Severity1: TMenuItem;
    CostPerSeverity1: TMenuItem;
    WebPanel1: TPanel;
    wpMain: TPanel;
    DashBoards1: TMenuItem;
    Maintenance1: TMenuItem;
    Loads1: TMenuItem;
    procedure mmLogoutClick(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure btnUserAccessClick(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure Budgets1Click(Sender: TObject);
    procedure FinancialPeriodClick(Sender: TObject);
    procedure Costinggroups1Click(Sender: TObject);
    procedure EMailNotifications1Click(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure Maintenance1Click(Sender: TObject);
    procedure LoadPlanningSummaryClick(Sender: TObject);
    procedure Company1Click(Sender: TObject);
    procedure Loads1Click(Sender: TObject);
    procedure Attendants1Click(Sender: TObject);
    procedure Depots1Click(Sender: TObject);
  private
    { Private declarations }
    newformLogin : Tfrmlogin;
    procedure CheckLogin;
    function DoUserAccess(sUserCode : String) : Boolean;
  public
    { Public declarations }
    frm : TForm;
    username : string;
    UserAccess : TUser;
  protected procedure LoadDFMValues; override; end;

var
  frmmain: Tfrmmain;

implementation

{$R *.dfm}

uses
  settings.useraccess, planning.enquiry,
  assets.settings.budgetsownfleet,
  USystemPeriods,
  SystemCostGroupsView,
  SystemAutoMailView,
  dashboard.maintenance,
  //SystemSetup,
  dashboard.loads,
  SystemSettings,
  DieselAttendants,
  DieselDepots;

procedure Tfrmmain.Attendants1Click(Sender: TObject);
begin
  try
    if Assigned(frm) then
      frm.Free;
  except

  end;

  Application.CreateForm(TfrmFuelAttendants, wpMain.ElementID, frm);
end;

procedure Tfrmmain.btnUserAccessClick(Sender: TObject);

begin
  try
    if Assigned(frm) then
      frm.Free;
  except

  end;

  Application.CreateForm(TfrmUserAccess, wpMain.ElementID, frm);
end;

procedure Tfrmmain.Budgets1Click(Sender: TObject);
begin
  try
    if Assigned(frm) then
      frm.Free;
  except

  end;

  Application.CreateForm(TfrmBudgetsOwnFleet, wpMain.ElementID, frm);
end;

procedure Tfrmmain.CheckLogin;
  var
    sUser,
    json : String;
    javascriptobject: JSValue;
  procedure OnError(Error: TXDataClientError);
  begin
    CheckLogin;
  end;
  procedure OnResponse (Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) and (Response.StatusCode > 299) then
        begin
          CheckLogin;
        end
      else
        begin
          json := string(Response.ResponseText);
          javascriptobject := TJSJSON.parse(json);
          UserAccess := TUser(javascriptobject);

          dmdata.LStorage.setvalue(stfmssystem.connection.TokenName, dmdata.sToken);
          dmdata.LStorage.setvalue(stfmssystem.connection.Username, sUser);
        end;
    end;
begin
  sUser := dmdata.LStorage.getvalue(stfmssystem.connection.UserName);
  dmdata.sToken := dmdata.LStorage.getvalue(stfmssystem.connection.TokenName);

  webConnect.RawInvoke('IstfmsSystemService.GetUser', [sUser], @OnResponse, @OnError);
end;

procedure Tfrmmain.Company1Click(Sender: TObject);
begin
  try
    if Assigned(frm) then
      frm.Free;
  except

  end;

  Application.CreateForm(TfrmSystemSettings, wpMain.ElementID, frm);
end;

procedure Tfrmmain.Costinggroups1Click(Sender: TObject);
begin
  try
    if Assigned(frm) then
      frm.Free;
  except

  end;

  Application.CreateForm(TfrmCostGroupsView, wpMain.ElementID, frm);
end;

procedure Tfrmmain.Depots1Click(Sender: TObject);
begin
  try
    if Assigned(frm) then
      frm.Free;
  except

  end;

  Application.CreateForm(TfrmDieselDepots, wpMain.ElementID, frm);
end;

function Tfrmmain.DoUserAccess(sUserCode : String) : Boolean;
  var
    json : string;
  procedure OnResponse  (Response : TXDataClientResponse);
  begin
    json := string(Response.ResponseText);
    if Uppercase(json) = 'TRUE' then
      Result := True
    else
      Result := False;
  end;
begin
  Result := False;
  webConnect.RawInvoke('IstfmsSystemService.GetUserAcess', [dmdata.LStorage.getvalue(stfmssystem.connection.UserName)], @OnResponse);
end;

procedure Tfrmmain.EMailNotifications1Click(Sender: TObject);
begin
  try
    if Assigned(frm) then
      frm.Free;
  except

  end;

  Application.CreateForm(TfrmSystemAutoMailView, wpMain.ElementID, frm);
end;

procedure Tfrmmain.FinancialPeriodClick(Sender: TObject);
begin
  try
    if Assigned(frm) then
      frm.Free;
  except

  end;

  Application.CreateForm(TfrmSystemMonths, wpMain.ElementID, frm);
end;

procedure Tfrmmain.Maintenance1Click(Sender: TObject);
  procedure AfterCreate(AForm : TObject);
  begin
    with (frm as TfrmDashBoardMaintenance) do
      begin

      end;
  end;
begin
  try
    if Assigned(frm) then
      frm.Free;
  except

  end;

  Application.CreateForm(TfrmDashBoardMaintenance, wpMain.ElementID, frm, @AfterCreate);
end;

procedure Tfrmmain.mmLogoutClick(Sender: TObject);
begin
  dmdata.LStorage.setvalue(stfmssystem.connection.ExpiryDate, FloatToStr(0));
  dmdata.LStorage.setvalue(stfmssystem.connection.UserName, '');
  dmdata.LStorage.setvalue(stfmssystem.connection.TokenName, '');
  dmdata.LStorage.setvalue(stfmssystem.connection.ErrorCount, '0');
  Close;
end;

procedure Tfrmmain.LoadPlanningSummaryClick(Sender: TObject);
begin
  try
    if Assigned(frm) then
      frm.Free;
  except

  end;

  Application.CreateForm(TfrmPlanningEnquiry, wpMain.ElementID, frm);
end;

procedure Tfrmmain.Loads1Click(Sender: TObject);
  procedure AfterCreate(AForm : TObject);
  begin
    with (frm as TfrmDashboardLoads) do
      begin

      end;
  end;
begin
  try
    if Assigned(frm) then
      frm.Free;
  except

  end;

  Application.CreateForm(TfrmDashboardLoads, wpMain.ElementID, frm, @AfterCreate);
end;

procedure Tfrmmain.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin

  Action := caFree;
end;

procedure Tfrmmain.WebFormCreate(Sender: TObject);
  var
    jsr: TJSDOMRect;

  procedure AfterShowModal(AValue: TModalResult);
  begin
    dmdata.LStorage.setvalue(stfmssystem.connection.ExpiryDate, FloatToStr(Incminute(now, 5)));
    CheckLogin;

  end;
begin

  wpMain.Visible := True;
  //wpBottom.Visible := True;
  //wicLogo.Left := (Width - wicLogo.Width) div 2;
  //wicLogo.Top := (Height - wicLogo.Height) div 2;
  if (dmdata.LStorage.getvalue(stfmssystem.connection.Username) <> '') and
     (dmdata.LStorage.getvalue(stfmssystem.connection.Tokenname) <> '') then
    begin
      dmdata.sToken := dmdata.LStorage.getvalue(stfmssystem.connection.TokenName);
      if dmdata.LStorage.getvalue(stfmssystem.connection.ExpiryDate) = '' then
        dmdata.LStorage.setvalue(stfmssystem.connection.ExpiryDate, FloatToStr(0));
      if StrToFloat(dmdata.LStorage.getvalue(stfmssystem.connection.ExpiryDate)) < Now then
        begin
          jsr := document.body.getBoundingClientRect;
          newformLogin := Tfrmlogin.CreateNew;
          newformLogin.Popup := true;
          newformLogin.PopupOpacity := 0.2;
          newformLogin.Height := 207;
          newformLogin.Width := 299;
          newformLogin.Top := Round((window.innerheight - newformLogin.Height) / 2);
          newformLogin.Left := Round((jsr.right - jsr.left - newformLogin.Width) / 2);
          newformLogin.Showmodal(@AfterShowModal);
        end
      else
        begin
          //CheckLogin;
          //newform := Tfrmlogin.CreateNew;
          //newform.Popup := true;
          //newform.PopupOpacity := 0.2;
          //newform.Showmodal(@AfterShowModal);
        end;

    end
  else
    begin
      jsr := document.body.getBoundingClientRect;
      newformLogin := Tfrmlogin.CreateNew;
      newformLogin.Popup := true;
      newformLogin.PopupOpacity := 0.2;
      newformLogin.Height := 207;
      newformLogin.Width := 299;
      newformLogin.Top := Round((window.innerheight - newformLogin.Height) / 2);
      newformLogin.Left := Round((jsr.right - jsr.left - newformLogin.Width) / 2);
      newformLogin.Showmodal(@AfterShowModal);
    end;

end;

procedure Tfrmmain.WebFormResize(Sender: TObject);
  var
    jsr: TJSDOMRect;
begin
  if assigned(newformLogin) then
    begin
      jsr := document.body.getBoundingClientRect;

      newformLogin.Height := 207;
      newformLogin.Width := 299;
      newformLogin.Top := Round((window.innerheight - newformLogin.Height) / 2);
      newformLogin.Left := Round((jsr.right - jsr.left - newformLogin.Width) / 2);
    end;
end;

procedure Tfrmmain.LoadDFMValues;
begin
  inherited LoadDFMValues;

  mdMain := TMessageDlg.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  wpMain := TPanel.Create(Self);
  wmSubsMainMenu := TMainMenu.Create(Self);
  btnFile := TMenuItem.Create(Self);
  btnLogout := TMenuItem.Create(Self);
  btnCompany := TMenuItem.Create(Self);
  btnCompanySettings := TMenuItem.Create(Self);
  Company1 := TMenuItem.Create(Self);
  btnUserAccess := TMenuItem.Create(Self);
  SMSNumbers1 := TMenuItem.Create(Self);
  SMSNumbers2 := TMenuItem.Create(Self);
  Costinggroups1 := TMenuItem.Create(Self);
  Costinggroups2 := TMenuItem.Create(Self);
  EMailNotifications1 := TMenuItem.Create(Self);
  FinancialPeriod := TMenuItem.Create(Self);
  SagePastelExport1 := TMenuItem.Create(Self);
  SagePastelExport2 := TMenuItem.Create(Self);
  SubsUserAccess1 := TMenuItem.Create(Self);
  btnCompanyTransactions := TMenuItem.Create(Self);
  BankReconciliation1 := TMenuItem.Create(Self);
  VehicleAsset1 := TMenuItem.Create(Self);
  Settings1 := TMenuItem.Create(Self);
  Budgets1 := TMenuItem.Create(Self);
  VehicleGroup1 := TMenuItem.Create(Self);
  VehicleCatagories1 := TMenuItem.Create(Self);
  AxleMassSetup1 := TMenuItem.Create(Self);
  VehicleUnitSetup1 := TMenuItem.Create(Self);
  CombinationSetup1 := TMenuItem.Create(Self);
  ransactions1 := TMenuItem.Create(Self);
  VehicleServiceHistory1 := TMenuItem.Create(Self);
  VehicleServiceHistory2 := TMenuItem.Create(Self);
  VehicleMovement1 := TMenuItem.Create(Self);
  VehicleMovement2 := TMenuItem.Create(Self);
  ShiftChange1 := TMenuItem.Create(Self);
  Reports2 := TMenuItem.Create(Self);
  LicenseCOFPermitExpiryDates1 := TMenuItem.Create(Self);
  LicenseCOFPermitExpiryDates2 := TMenuItem.Create(Self);
  DailyCheckList1 := TMenuItem.Create(Self);
  DailyCheckList2 := TMenuItem.Create(Self);
  ExportFleetList1 := TMenuItem.Create(Self);
  Employees1 := TMenuItem.Create(Self);
  Settings2 := TMenuItem.Create(Self);
  EmployeeInformation1 := TMenuItem.Create(Self);
  EmployeeInformation2 := TMenuItem.Create(Self);
  SetupPublicHoliday1 := TMenuItem.Create(Self);
  SetupYearsweetDays1 := TMenuItem.Create(Self);
  CommisionTotalValueSetup1 := TMenuItem.Create(Self);
  ransactions2 := TMenuItem.Create(Self);
  EmployeePlanning1 := TMenuItem.Create(Self);
  EmployeePlanning2 := TMenuItem.Create(Self);
  Counselling1 := TMenuItem.Create(Self);
  Counselling2 := TMenuItem.Create(Self);
  PPEIsue1 := TMenuItem.Create(Self);
  PPEIsue2 := TMenuItem.Create(Self);
  EmployeeDailyCheckList1 := TMenuItem.Create(Self);
  ActivityLog1 := TMenuItem.Create(Self);
  ransactions3 := TMenuItem.Create(Self);
  ExpiryDates1 := TMenuItem.Create(Self);
  Medical1 := TMenuItem.Create(Self);
  ExpiryDates2 := TMenuItem.Create(Self);
  PDrP1 := TMenuItem.Create(Self);
  PDrP2 := TMenuItem.Create(Self);
  Workspermit1 := TMenuItem.Create(Self);
  Workspermit2 := TMenuItem.Create(Self);
  raining1 := TMenuItem.Create(Self);
  raining2 := TMenuItem.Create(Self);
  FatiqueManagement1 := TMenuItem.Create(Self);
  FatiqueManagement2 := TMenuItem.Create(Self);
  WarningList1 := TMenuItem.Create(Self);
  CounselingReport1 := TMenuItem.Create(Self);
  CounselingReport2 := TMenuItem.Create(Self);
  CommisionReportTotalValue1 := TMenuItem.Create(Self);
  CommisionReportTotalValue2 := TMenuItem.Create(Self);
  ActivityReport1 := TMenuItem.Create(Self);
  btnSuppliers := TMenuItem.Create(Self);
  Settings3 := TMenuItem.Create(Self);
  Accounts1 := TMenuItem.Create(Self);
  btnSupplierSetup := TMenuItem.Create(Self);
  btnSubContractorPortal := TMenuItem.Create(Self);
  Portal1 := TMenuItem.Create(Self);
  Remittance1 := TMenuItem.Create(Self);
  Payments1 := TMenuItem.Create(Self);
  Sup1 := TMenuItem.Create(Self);
  Payments2 := TMenuItem.Create(Self);
  Payments3 := TMenuItem.Create(Self);
  UpfrontDieselReceipt1 := TMenuItem.Create(Self);
  UpfrontDieselReceipt2 := TMenuItem.Create(Self);
  WriteOffDifferances1 := TMenuItem.Create(Self);
  AllocateUnAllocate1 := TMenuItem.Create(Self);
  ReverseReceiptPayments1 := TMenuItem.Create(Self);
  ransaction1 := TMenuItem.Create(Self);
  SupplierAgeAnalysis1 := TMenuItem.Create(Self);
  Remittances1 := TMenuItem.Create(Self);
  DetailLedger1 := TMenuItem.Create(Self);
  Customers1 := TMenuItem.Create(Self);
  Settings4 := TMenuItem.Create(Self);
  accounts2 := TMenuItem.Create(Self);
  ransactions4 := TMenuItem.Create(Self);
  CustomerReceipt1 := TMenuItem.Create(Self);
  WriteOffDifferences1 := TMenuItem.Create(Self);
  WriteOffDifferences2 := TMenuItem.Create(Self);
  ReversalReceiptPayments1 := TMenuItem.Create(Self);
  ransactions5 := TMenuItem.Create(Self);
  CustomerAgeAnalysis1 := TMenuItem.Create(Self);
  CustomerAgeAnalysis2 := TMenuItem.Create(Self);
  CustomerDetailledger1 := TMenuItem.Create(Self);
  LoadSystem1 := TMenuItem.Create(Self);
  Settings5 := TMenuItem.Create(Self);
  SetupContracts1 := TMenuItem.Create(Self);
  Settings6 := TMenuItem.Create(Self);
  CreateLoadConfirmations1 := TMenuItem.Create(Self);
  CreateLoadConfirmations2 := TMenuItem.Create(Self);
  ripsheetPlanning1 := TMenuItem.Create(Self);
  ripsheetPlanning2 := TMenuItem.Create(Self);
  CreateMultiLoadinvoices1 := TMenuItem.Create(Self);
  CreateMultiLoadinvoices2 := TMenuItem.Create(Self);
  CreateLinkedLoadsInvoices1 := TMenuItem.Create(Self);
  CreateLinkedLoadsInvoices2 := TMenuItem.Create(Self);
  LoadDebitNotes1 := TMenuItem.Create(Self);
  ViewSubContractorInvoices1 := TMenuItem.Create(Self);
  ViewSubContractorInvoices2 := TMenuItem.Create(Self);
  BatchProgressInvoices1 := TMenuItem.Create(Self);
  Reports3 := TMenuItem.Create(Self);
  LoadsReports1 := TMenuItem.Create(Self);
  ProfitLoss1 := TMenuItem.Create(Self);
  Progress1 := TMenuItem.Create(Self);
  Outstanding1 := TMenuItem.Create(Self);
  VarrianceControlerProgress1 := TMenuItem.Create(Self);
  ControlerProgress1 := TMenuItem.Create(Self);
  IncomeReports1 := TMenuItem.Create(Self);
  vsFueloncapturedkms1 := TMenuItem.Create(Self);
  vsFeuloncalculatedkms1 := TMenuItem.Create(Self);
  vsFeuloncalculatedkms2 := TMenuItem.Create(Self);
  Driver1 := TMenuItem.Create(Self);
  Driver2 := TMenuItem.Create(Self);
  Overloading1 := TMenuItem.Create(Self);
  Overloading2 := TMenuItem.Create(Self);
  Workingday1 := TMenuItem.Create(Self);
  Workingday2 := TMenuItem.Create(Self);
  Provisions1 := TMenuItem.Create(Self);
  Provisions2 := TMenuItem.Create(Self);
  LoadsInfoOver12Months1 := TMenuItem.Create(Self);
  LoadsInfoOver12Months2 := TMenuItem.Create(Self);
  cancelledLoads1 := TMenuItem.Create(Self);
  cancelledLoads2 := TMenuItem.Create(Self);
  Planning1 := TMenuItem.Create(Self);
  SubContractorEMails1 := TMenuItem.Create(Self);
  LoadPlanningSummary := TMenuItem.Create(Self);
  ControllerPlanningProfitLoss1 := TMenuItem.Create(Self);
  ControllerPlanningProfitLoss2 := TMenuItem.Create(Self);
  FleetInformation1 := TMenuItem.Create(Self);
  FleetInformation2 := TMenuItem.Create(Self);
  btnFuelSystem := TMenuItem.Create(Self);
  Setup1 := TMenuItem.Create(Self);
  Attendants1 := TMenuItem.Create(Self);
  Depots1 := TMenuItem.Create(Self);
  Attendants2 := TMenuItem.Create(Self);
  FuelPriceIncreaseDecrease1 := TMenuItem.Create(Self);
  btnFuelSystemTransactions := TMenuItem.Create(Self);
  DailyControlSheets1 := TMenuItem.Create(Self);
  DailyControlSheets2 := TMenuItem.Create(Self);
  BulkPurchaseOrder1 := TMenuItem.Create(Self);
  BulkPurchaseOrder2 := TMenuItem.Create(Self);
  btnFuelOrders := TMenuItem.Create(Self);
  FuelInvoices1 := TMenuItem.Create(Self);
  GetDieselOrdersFromSupplier1 := TMenuItem.Create(Self);
  GetDieselOrdersFromSupplier2 := TMenuItem.Create(Self);
  FeulDebitNotes1 := TMenuItem.Create(Self);
  UpdateInvoicedFuelOrders1 := TMenuItem.Create(Self);
  OwnFleetDieselBulkProcess1 := TMenuItem.Create(Self);
  Reports1 := TMenuItem.Create(Self);
  CostVsIncomeReports1 := TMenuItem.Create(Self);
  DieselDepot1 := TMenuItem.Create(Self);
  DieselDepot2 := TMenuItem.Create(Self);
  DepotStocklevelreport1 := TMenuItem.Create(Self);
  DepotStocklevelreport2 := TMenuItem.Create(Self);
  DieselvsKmsreport1 := TMenuItem.Create(Self);
  DieselvsKmsreport2 := TMenuItem.Create(Self);
  DriverFeul1 := TMenuItem.Create(Self);
  VehicleFuel1 := TMenuItem.Create(Self);
  DailyControllSheetsReports1 := TMenuItem.Create(Self);
  FuelManSlipInformation1 := TMenuItem.Create(Self);
  FuelManSlipInformation2 := TMenuItem.Create(Self);
  WashbaySystem1 := TMenuItem.Create(Self);
  Settings7 := TMenuItem.Create(Self);
  Washbaydepots1 := TMenuItem.Create(Self);
  ImportSetup1 := TMenuItem.Create(Self);
  Settings8 := TMenuItem.Create(Self);
  ProcessTransactions1 := TMenuItem.Create(Self);
  ProcessTransactions2 := TMenuItem.Create(Self);
  DebitNote1 := TMenuItem.Create(Self);
  DebitNote2 := TMenuItem.Create(Self);
  GetWashbayOrderFromSupplier1 := TMenuItem.Create(Self);
  Reports4 := TMenuItem.Create(Self);
  Washbayorders1 := TMenuItem.Create(Self);
  Washbayorders2 := TMenuItem.Create(Self);
  ollSystem1 := TMenuItem.Create(Self);
  ollSystem2 := TMenuItem.Create(Self);
  ollProcessing1 := TMenuItem.Create(Self);
  Reports5 := TMenuItem.Create(Self);
  ollsPerVehicle1 := TMenuItem.Create(Self);
  ollsPerVehicle2 := TMenuItem.Create(Self);
  Settings9 := TMenuItem.Create(Self);
  Warehous1 := TMenuItem.Create(Self);
  Warehous2 := TMenuItem.Create(Self);
  CostDescription1 := TMenuItem.Create(Self);
  CostDescription2 := TMenuItem.Create(Self);
  Waranties1 := TMenuItem.Create(Self);
  Waranties2 := TMenuItem.Create(Self);
  VehicleserviceTypes1 := TMenuItem.Create(Self);
  Settings10 := TMenuItem.Create(Self);
  JobCards1 := TMenuItem.Create(Self);
  JobCards2 := TMenuItem.Create(Self);
  PurchaseRequest1 := TMenuItem.Create(Self);
  PurchaseRequest2 := TMenuItem.Create(Self);
  PurchaseDelivery1 := TMenuItem.Create(Self);
  PurchaseDelivery2 := TMenuItem.Create(Self);
  SupplierCreditNotes1 := TMenuItem.Create(Self);
  SupplierCreditNotes2 := TMenuItem.Create(Self);
  CustomerCreditNotes1 := TMenuItem.Create(Self);
  CustomerCreditNotes2 := TMenuItem.Create(Self);
  StockTake1 := TMenuItem.Create(Self);
  StockTake2 := TMenuItem.Create(Self);
  Customers2 := TMenuItem.Create(Self);
  Customers3 := TMenuItem.Create(Self);
  RePrintCreditNote1 := TMenuItem.Create(Self);
  CustomersSuppliers1 := TMenuItem.Create(Self);
  Supplier1 := TMenuItem.Create(Self);
  Reports6 := TMenuItem.Create(Self);
  StockLedger1 := TMenuItem.Create(Self);
  StockLedger2 := TMenuItem.Create(Self);
  StockQtyOnHand1 := TMenuItem.Create(Self);
  StockQtyOnHand2 := TMenuItem.Create(Self);
  StockGoodsReturnNotes1 := TMenuItem.Create(Self);
  StockGoodsReturnNotes2 := TMenuItem.Create(Self);
  StockQtyOnBackOrder1 := TMenuItem.Create(Self);
  StockQtyOnBackOrder2 := TMenuItem.Create(Self);
  GeneralLedgerPerCostCenter1 := TMenuItem.Create(Self);
  GeneralLedgerPerCostCenter2 := TMenuItem.Create(Self);
  MiscellaneousTransactions1 := TMenuItem.Create(Self);
  MiscellaneousTransactions2 := TMenuItem.Create(Self);
  MiscellaneousCustomerInvoice1 := TMenuItem.Create(Self);
  CustomerCreditNote1 := TMenuItem.Create(Self);
  CustomerCreditNote2 := TMenuItem.Create(Self);
  RePrintCustomerInvoice1 := TMenuItem.Create(Self);
  Customer1 := TMenuItem.Create(Self);
  Customer2 := TMenuItem.Create(Self);
  RePrintCustomerInvoice2 := TMenuItem.Create(Self);
  Customer3 := TMenuItem.Create(Self);
  Customer4 := TMenuItem.Create(Self);
  RePrintCustomerDebitNote1 := TMenuItem.Create(Self);
  Customer5 := TMenuItem.Create(Self);
  Customer6 := TMenuItem.Create(Self);
  RePrintCustomerDebitNote2 := TMenuItem.Create(Self);
  SupplierDebitNote1 := TMenuItem.Create(Self);
  SupplierDebitNote2 := TMenuItem.Create(Self);
  ManagementReports1 := TMenuItem.Create(Self);
  ManagementReports2 := TMenuItem.Create(Self);
  ransactionJournals1 := TMenuItem.Create(Self);
  ransactionJournals2 := TMenuItem.Create(Self);
  ProductSalesAnalysis1 := TMenuItem.Create(Self);
  ProductSalesAnalysis2 := TMenuItem.Create(Self);
  VehicleCostReports1 := TMenuItem.Create(Self);
  VehicleCostReports2 := TMenuItem.Create(Self);
  N12MonthClientSales1 := TMenuItem.Create(Self);
  N12MonthClientSales2 := TMenuItem.Create(Self);
  ExportSubsDieselInformation1 := TMenuItem.Create(Self);
  DashBoards1 := TMenuItem.Create(Self);
  Maintenance1 := TMenuItem.Create(Self);
  Loads1 := TMenuItem.Create(Self);
  ExportSubsDieselInformation2 := TMenuItem.Create(Self);
  ransactions6 := TMenuItem.Create(Self);
  AIRegister1 := TMenuItem.Create(Self);
  ransactions7 := TMenuItem.Create(Self);
  ypes1 := TMenuItem.Create(Self);
  ypes2 := TMenuItem.Create(Self);
  DaysSinceLastTypes1 := TMenuItem.Create(Self);
  DaysSinceLastTypes2 := TMenuItem.Create(Self);
  CostPerCause1 := TMenuItem.Create(Self);
  CostPerCause2 := TMenuItem.Create(Self);
  Severity1 := TMenuItem.Create(Self);
  CostPerSeverity1 := TMenuItem.Create(Self);
  Progressreport1 := TMenuItem.Create(Self);
  Progressreport2 := TMenuItem.Create(Self);
  AIReports1 := TMenuItem.Create(Self);
  webconnect := TXDataWebClient.Create(Self);
  qUser := TXDataWebDataSet.Create(Self);

  mdMain.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  wpMain.BeforeLoadDFMValues;
  wmSubsMainMenu.BeforeLoadDFMValues;
  btnFile.BeforeLoadDFMValues;
  btnLogout.BeforeLoadDFMValues;
  btnCompany.BeforeLoadDFMValues;
  btnCompanySettings.BeforeLoadDFMValues;
  Company1.BeforeLoadDFMValues;
  btnUserAccess.BeforeLoadDFMValues;
  SMSNumbers1.BeforeLoadDFMValues;
  SMSNumbers2.BeforeLoadDFMValues;
  Costinggroups1.BeforeLoadDFMValues;
  Costinggroups2.BeforeLoadDFMValues;
  EMailNotifications1.BeforeLoadDFMValues;
  FinancialPeriod.BeforeLoadDFMValues;
  SagePastelExport1.BeforeLoadDFMValues;
  SagePastelExport2.BeforeLoadDFMValues;
  SubsUserAccess1.BeforeLoadDFMValues;
  btnCompanyTransactions.BeforeLoadDFMValues;
  BankReconciliation1.BeforeLoadDFMValues;
  VehicleAsset1.BeforeLoadDFMValues;
  Settings1.BeforeLoadDFMValues;
  Budgets1.BeforeLoadDFMValues;
  VehicleGroup1.BeforeLoadDFMValues;
  VehicleCatagories1.BeforeLoadDFMValues;
  AxleMassSetup1.BeforeLoadDFMValues;
  VehicleUnitSetup1.BeforeLoadDFMValues;
  CombinationSetup1.BeforeLoadDFMValues;
  ransactions1.BeforeLoadDFMValues;
  VehicleServiceHistory1.BeforeLoadDFMValues;
  VehicleServiceHistory2.BeforeLoadDFMValues;
  VehicleMovement1.BeforeLoadDFMValues;
  VehicleMovement2.BeforeLoadDFMValues;
  ShiftChange1.BeforeLoadDFMValues;
  Reports2.BeforeLoadDFMValues;
  LicenseCOFPermitExpiryDates1.BeforeLoadDFMValues;
  LicenseCOFPermitExpiryDates2.BeforeLoadDFMValues;
  DailyCheckList1.BeforeLoadDFMValues;
  DailyCheckList2.BeforeLoadDFMValues;
  ExportFleetList1.BeforeLoadDFMValues;
  Employees1.BeforeLoadDFMValues;
  Settings2.BeforeLoadDFMValues;
  EmployeeInformation1.BeforeLoadDFMValues;
  EmployeeInformation2.BeforeLoadDFMValues;
  SetupPublicHoliday1.BeforeLoadDFMValues;
  SetupYearsweetDays1.BeforeLoadDFMValues;
  CommisionTotalValueSetup1.BeforeLoadDFMValues;
  ransactions2.BeforeLoadDFMValues;
  EmployeePlanning1.BeforeLoadDFMValues;
  EmployeePlanning2.BeforeLoadDFMValues;
  Counselling1.BeforeLoadDFMValues;
  Counselling2.BeforeLoadDFMValues;
  PPEIsue1.BeforeLoadDFMValues;
  PPEIsue2.BeforeLoadDFMValues;
  EmployeeDailyCheckList1.BeforeLoadDFMValues;
  ActivityLog1.BeforeLoadDFMValues;
  ransactions3.BeforeLoadDFMValues;
  ExpiryDates1.BeforeLoadDFMValues;
  Medical1.BeforeLoadDFMValues;
  ExpiryDates2.BeforeLoadDFMValues;
  PDrP1.BeforeLoadDFMValues;
  PDrP2.BeforeLoadDFMValues;
  Workspermit1.BeforeLoadDFMValues;
  Workspermit2.BeforeLoadDFMValues;
  raining1.BeforeLoadDFMValues;
  raining2.BeforeLoadDFMValues;
  FatiqueManagement1.BeforeLoadDFMValues;
  FatiqueManagement2.BeforeLoadDFMValues;
  WarningList1.BeforeLoadDFMValues;
  CounselingReport1.BeforeLoadDFMValues;
  CounselingReport2.BeforeLoadDFMValues;
  CommisionReportTotalValue1.BeforeLoadDFMValues;
  CommisionReportTotalValue2.BeforeLoadDFMValues;
  ActivityReport1.BeforeLoadDFMValues;
  btnSuppliers.BeforeLoadDFMValues;
  Settings3.BeforeLoadDFMValues;
  Accounts1.BeforeLoadDFMValues;
  btnSupplierSetup.BeforeLoadDFMValues;
  btnSubContractorPortal.BeforeLoadDFMValues;
  Portal1.BeforeLoadDFMValues;
  Remittance1.BeforeLoadDFMValues;
  Payments1.BeforeLoadDFMValues;
  Sup1.BeforeLoadDFMValues;
  Payments2.BeforeLoadDFMValues;
  Payments3.BeforeLoadDFMValues;
  UpfrontDieselReceipt1.BeforeLoadDFMValues;
  UpfrontDieselReceipt2.BeforeLoadDFMValues;
  WriteOffDifferances1.BeforeLoadDFMValues;
  AllocateUnAllocate1.BeforeLoadDFMValues;
  ReverseReceiptPayments1.BeforeLoadDFMValues;
  ransaction1.BeforeLoadDFMValues;
  SupplierAgeAnalysis1.BeforeLoadDFMValues;
  Remittances1.BeforeLoadDFMValues;
  DetailLedger1.BeforeLoadDFMValues;
  Customers1.BeforeLoadDFMValues;
  Settings4.BeforeLoadDFMValues;
  accounts2.BeforeLoadDFMValues;
  ransactions4.BeforeLoadDFMValues;
  CustomerReceipt1.BeforeLoadDFMValues;
  WriteOffDifferences1.BeforeLoadDFMValues;
  WriteOffDifferences2.BeforeLoadDFMValues;
  ReversalReceiptPayments1.BeforeLoadDFMValues;
  ransactions5.BeforeLoadDFMValues;
  CustomerAgeAnalysis1.BeforeLoadDFMValues;
  CustomerAgeAnalysis2.BeforeLoadDFMValues;
  CustomerDetailledger1.BeforeLoadDFMValues;
  LoadSystem1.BeforeLoadDFMValues;
  Settings5.BeforeLoadDFMValues;
  SetupContracts1.BeforeLoadDFMValues;
  Settings6.BeforeLoadDFMValues;
  CreateLoadConfirmations1.BeforeLoadDFMValues;
  CreateLoadConfirmations2.BeforeLoadDFMValues;
  ripsheetPlanning1.BeforeLoadDFMValues;
  ripsheetPlanning2.BeforeLoadDFMValues;
  CreateMultiLoadinvoices1.BeforeLoadDFMValues;
  CreateMultiLoadinvoices2.BeforeLoadDFMValues;
  CreateLinkedLoadsInvoices1.BeforeLoadDFMValues;
  CreateLinkedLoadsInvoices2.BeforeLoadDFMValues;
  LoadDebitNotes1.BeforeLoadDFMValues;
  ViewSubContractorInvoices1.BeforeLoadDFMValues;
  ViewSubContractorInvoices2.BeforeLoadDFMValues;
  BatchProgressInvoices1.BeforeLoadDFMValues;
  Reports3.BeforeLoadDFMValues;
  LoadsReports1.BeforeLoadDFMValues;
  ProfitLoss1.BeforeLoadDFMValues;
  Progress1.BeforeLoadDFMValues;
  Outstanding1.BeforeLoadDFMValues;
  VarrianceControlerProgress1.BeforeLoadDFMValues;
  ControlerProgress1.BeforeLoadDFMValues;
  IncomeReports1.BeforeLoadDFMValues;
  vsFueloncapturedkms1.BeforeLoadDFMValues;
  vsFeuloncalculatedkms1.BeforeLoadDFMValues;
  vsFeuloncalculatedkms2.BeforeLoadDFMValues;
  Driver1.BeforeLoadDFMValues;
  Driver2.BeforeLoadDFMValues;
  Overloading1.BeforeLoadDFMValues;
  Overloading2.BeforeLoadDFMValues;
  Workingday1.BeforeLoadDFMValues;
  Workingday2.BeforeLoadDFMValues;
  Provisions1.BeforeLoadDFMValues;
  Provisions2.BeforeLoadDFMValues;
  LoadsInfoOver12Months1.BeforeLoadDFMValues;
  LoadsInfoOver12Months2.BeforeLoadDFMValues;
  cancelledLoads1.BeforeLoadDFMValues;
  cancelledLoads2.BeforeLoadDFMValues;
  Planning1.BeforeLoadDFMValues;
  SubContractorEMails1.BeforeLoadDFMValues;
  LoadPlanningSummary.BeforeLoadDFMValues;
  ControllerPlanningProfitLoss1.BeforeLoadDFMValues;
  ControllerPlanningProfitLoss2.BeforeLoadDFMValues;
  FleetInformation1.BeforeLoadDFMValues;
  FleetInformation2.BeforeLoadDFMValues;
  btnFuelSystem.BeforeLoadDFMValues;
  Setup1.BeforeLoadDFMValues;
  Attendants1.BeforeLoadDFMValues;
  Depots1.BeforeLoadDFMValues;
  Attendants2.BeforeLoadDFMValues;
  FuelPriceIncreaseDecrease1.BeforeLoadDFMValues;
  btnFuelSystemTransactions.BeforeLoadDFMValues;
  DailyControlSheets1.BeforeLoadDFMValues;
  DailyControlSheets2.BeforeLoadDFMValues;
  BulkPurchaseOrder1.BeforeLoadDFMValues;
  BulkPurchaseOrder2.BeforeLoadDFMValues;
  btnFuelOrders.BeforeLoadDFMValues;
  FuelInvoices1.BeforeLoadDFMValues;
  GetDieselOrdersFromSupplier1.BeforeLoadDFMValues;
  GetDieselOrdersFromSupplier2.BeforeLoadDFMValues;
  FeulDebitNotes1.BeforeLoadDFMValues;
  UpdateInvoicedFuelOrders1.BeforeLoadDFMValues;
  OwnFleetDieselBulkProcess1.BeforeLoadDFMValues;
  Reports1.BeforeLoadDFMValues;
  CostVsIncomeReports1.BeforeLoadDFMValues;
  DieselDepot1.BeforeLoadDFMValues;
  DieselDepot2.BeforeLoadDFMValues;
  DepotStocklevelreport1.BeforeLoadDFMValues;
  DepotStocklevelreport2.BeforeLoadDFMValues;
  DieselvsKmsreport1.BeforeLoadDFMValues;
  DieselvsKmsreport2.BeforeLoadDFMValues;
  DriverFeul1.BeforeLoadDFMValues;
  VehicleFuel1.BeforeLoadDFMValues;
  DailyControllSheetsReports1.BeforeLoadDFMValues;
  FuelManSlipInformation1.BeforeLoadDFMValues;
  FuelManSlipInformation2.BeforeLoadDFMValues;
  WashbaySystem1.BeforeLoadDFMValues;
  Settings7.BeforeLoadDFMValues;
  Washbaydepots1.BeforeLoadDFMValues;
  ImportSetup1.BeforeLoadDFMValues;
  Settings8.BeforeLoadDFMValues;
  ProcessTransactions1.BeforeLoadDFMValues;
  ProcessTransactions2.BeforeLoadDFMValues;
  DebitNote1.BeforeLoadDFMValues;
  DebitNote2.BeforeLoadDFMValues;
  GetWashbayOrderFromSupplier1.BeforeLoadDFMValues;
  Reports4.BeforeLoadDFMValues;
  Washbayorders1.BeforeLoadDFMValues;
  Washbayorders2.BeforeLoadDFMValues;
  ollSystem1.BeforeLoadDFMValues;
  ollSystem2.BeforeLoadDFMValues;
  ollProcessing1.BeforeLoadDFMValues;
  Reports5.BeforeLoadDFMValues;
  ollsPerVehicle1.BeforeLoadDFMValues;
  ollsPerVehicle2.BeforeLoadDFMValues;
  Settings9.BeforeLoadDFMValues;
  Warehous1.BeforeLoadDFMValues;
  Warehous2.BeforeLoadDFMValues;
  CostDescription1.BeforeLoadDFMValues;
  CostDescription2.BeforeLoadDFMValues;
  Waranties1.BeforeLoadDFMValues;
  Waranties2.BeforeLoadDFMValues;
  VehicleserviceTypes1.BeforeLoadDFMValues;
  Settings10.BeforeLoadDFMValues;
  JobCards1.BeforeLoadDFMValues;
  JobCards2.BeforeLoadDFMValues;
  PurchaseRequest1.BeforeLoadDFMValues;
  PurchaseRequest2.BeforeLoadDFMValues;
  PurchaseDelivery1.BeforeLoadDFMValues;
  PurchaseDelivery2.BeforeLoadDFMValues;
  SupplierCreditNotes1.BeforeLoadDFMValues;
  SupplierCreditNotes2.BeforeLoadDFMValues;
  CustomerCreditNotes1.BeforeLoadDFMValues;
  CustomerCreditNotes2.BeforeLoadDFMValues;
  StockTake1.BeforeLoadDFMValues;
  StockTake2.BeforeLoadDFMValues;
  Customers2.BeforeLoadDFMValues;
  Customers3.BeforeLoadDFMValues;
  RePrintCreditNote1.BeforeLoadDFMValues;
  CustomersSuppliers1.BeforeLoadDFMValues;
  Supplier1.BeforeLoadDFMValues;
  Reports6.BeforeLoadDFMValues;
  StockLedger1.BeforeLoadDFMValues;
  StockLedger2.BeforeLoadDFMValues;
  StockQtyOnHand1.BeforeLoadDFMValues;
  StockQtyOnHand2.BeforeLoadDFMValues;
  StockGoodsReturnNotes1.BeforeLoadDFMValues;
  StockGoodsReturnNotes2.BeforeLoadDFMValues;
  StockQtyOnBackOrder1.BeforeLoadDFMValues;
  StockQtyOnBackOrder2.BeforeLoadDFMValues;
  GeneralLedgerPerCostCenter1.BeforeLoadDFMValues;
  GeneralLedgerPerCostCenter2.BeforeLoadDFMValues;
  MiscellaneousTransactions1.BeforeLoadDFMValues;
  MiscellaneousTransactions2.BeforeLoadDFMValues;
  MiscellaneousCustomerInvoice1.BeforeLoadDFMValues;
  CustomerCreditNote1.BeforeLoadDFMValues;
  CustomerCreditNote2.BeforeLoadDFMValues;
  RePrintCustomerInvoice1.BeforeLoadDFMValues;
  Customer1.BeforeLoadDFMValues;
  Customer2.BeforeLoadDFMValues;
  RePrintCustomerInvoice2.BeforeLoadDFMValues;
  Customer3.BeforeLoadDFMValues;
  Customer4.BeforeLoadDFMValues;
  RePrintCustomerDebitNote1.BeforeLoadDFMValues;
  Customer5.BeforeLoadDFMValues;
  Customer6.BeforeLoadDFMValues;
  RePrintCustomerDebitNote2.BeforeLoadDFMValues;
  SupplierDebitNote1.BeforeLoadDFMValues;
  SupplierDebitNote2.BeforeLoadDFMValues;
  ManagementReports1.BeforeLoadDFMValues;
  ManagementReports2.BeforeLoadDFMValues;
  ransactionJournals1.BeforeLoadDFMValues;
  ransactionJournals2.BeforeLoadDFMValues;
  ProductSalesAnalysis1.BeforeLoadDFMValues;
  ProductSalesAnalysis2.BeforeLoadDFMValues;
  VehicleCostReports1.BeforeLoadDFMValues;
  VehicleCostReports2.BeforeLoadDFMValues;
  N12MonthClientSales1.BeforeLoadDFMValues;
  N12MonthClientSales2.BeforeLoadDFMValues;
  ExportSubsDieselInformation1.BeforeLoadDFMValues;
  DashBoards1.BeforeLoadDFMValues;
  Maintenance1.BeforeLoadDFMValues;
  Loads1.BeforeLoadDFMValues;
  ExportSubsDieselInformation2.BeforeLoadDFMValues;
  ransactions6.BeforeLoadDFMValues;
  AIRegister1.BeforeLoadDFMValues;
  ransactions7.BeforeLoadDFMValues;
  ypes1.BeforeLoadDFMValues;
  ypes2.BeforeLoadDFMValues;
  DaysSinceLastTypes1.BeforeLoadDFMValues;
  DaysSinceLastTypes2.BeforeLoadDFMValues;
  CostPerCause1.BeforeLoadDFMValues;
  CostPerCause2.BeforeLoadDFMValues;
  Severity1.BeforeLoadDFMValues;
  CostPerSeverity1.BeforeLoadDFMValues;
  Progressreport1.BeforeLoadDFMValues;
  Progressreport2.BeforeLoadDFMValues;
  AIReports1.BeforeLoadDFMValues;
  webconnect.BeforeLoadDFMValues;
  qUser.BeforeLoadDFMValues;
  try
    Name := 'frmmain';
    Width := 1024;
    Height := 679;
    Align := alClient;
    Caption := 'STFMS - Fleet Management - Main';
    Color := clSilver;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    FormContainer := 'appcontent';
    ParentFont := False;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    mdMain.SetParentComponent(Self);
    mdMain.Name := 'mdMain';
    mdMain.Left := 544;
    mdMain.Top := 272;
    mdMain.Width := 24;
    mdMain.Height := 24;
    mdMain.Buttons := [];
    mdMain.Opacity := 0.200000000000000000;
    mdMain.ElementButtonClassName := 'btn';
    mdMain.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    mdMain.ElementTitleClassName := 'text-body';
    mdMain.ElementContentClassName := 'text-body';
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 1024;
    WebPanel1.Height := 81;
    WebPanel1.Align := alTop;
    WebPanel1.ChildOrder := 1;
    WebPanel1.ElementBodyClassName := 'card-body';
    WebPanel1.TabOrder := 1;
    wpMain.SetParentComponent(Self);
    wpMain.Name := 'wpMain';
    wpMain.Left := 0;
    wpMain.Top := 81;
    wpMain.Width := 1024;
    wpMain.Height := 598;
    wpMain.Align := alClient;
    wpMain.ChildOrder := 3;
    wpMain.TabOrder := 2;
    wmSubsMainMenu.SetParentComponent(Self);
    wmSubsMainMenu.Name := 'wmSubsMainMenu';
    wmSubsMainMenu.AutoMerge := True;
    wmSubsMainMenu.Appearance.BackgroundColor := clSilver;
    wmSubsMainMenu.Appearance.HamburgerMenu.Caption := 'Menu';
    wmSubsMainMenu.Appearance.HamburgerMenu.CaptionColor := clBlack;
    wmSubsMainMenu.Appearance.HamburgerMenu.Visible := hmAlways;
    wmSubsMainMenu.Appearance.HamburgerMenu.ResponsiveMaxWidth := 2000;
    wmSubsMainMenu.Appearance.HoverFontColor := clBlack;
    wmSubsMainMenu.Appearance.SubmenuIndicator := '&#9658;';
    wmSubsMainMenu.Font.Charset := DEFAULT_CHARSET;
    wmSubsMainMenu.Font.Color := clWindowText;
    wmSubsMainMenu.Font.Height := -12;
    wmSubsMainMenu.Font.Name := 'Segoe UI';
    wmSubsMainMenu.Font.Style := [];
    wmSubsMainMenu.Left := 8;
    wmSubsMainMenu.Top := 8;
    btnFile.SetParentComponent(wmSubsMainMenu);
    btnFile.Name := 'btnFile';
    btnFile.Caption := 'File';
    btnLogout.SetParentComponent(btnFile);
    btnLogout.Name := 'btnLogout';
    btnLogout.Caption := 'Logout';
    SetEvent(btnLogout, Self, 'OnClick', 'mmLogoutClick');
    btnCompany.SetParentComponent(wmSubsMainMenu);
    btnCompany.Name := 'btnCompany';
    btnCompany.Caption := 'Company';
    btnCompanySettings.SetParentComponent(btnCompany);
    btnCompanySettings.Name := 'btnCompanySettings';
    btnCompanySettings.Caption := 'Settings';
    Company1.SetParentComponent(btnCompanySettings);
    Company1.Name := 'Company1';
    Company1.Caption := 'Company';
    SetEvent(Company1, Self, 'OnClick', 'Company1Click');
    btnUserAccess.SetParentComponent(btnCompanySettings);
    btnUserAccess.Name := 'btnUserAccess';
    btnUserAccess.Caption := 'User';
    SetEvent(btnUserAccess, Self, 'OnClick', 'btnUserAccessClick');
    SMSNumbers1.SetParentComponent(btnCompanySettings);
    SMSNumbers1.Name := 'SMSNumbers1';
    SMSNumbers1.Caption := 'SMS Numbers';
    SMSNumbers2.SetParentComponent(btnCompanySettings);
    SMSNumbers2.Name := 'SMSNumbers2';
    SMSNumbers2.Caption := 'Sites';
    Costinggroups1.SetParentComponent(btnCompanySettings);
    Costinggroups1.Name := 'Costinggroups1';
    Costinggroups1.Caption := 'Costing groups';
    SetEvent(Costinggroups1, Self, 'OnClick', 'Costinggroups1Click');
    Costinggroups2.SetParentComponent(btnCompanySettings);
    Costinggroups2.Name := 'Costinggroups2';
    Costinggroups2.Caption := 'Excel Export';
    EMailNotifications1.SetParentComponent(btnCompanySettings);
    EMailNotifications1.Name := 'EMailNotifications1';
    EMailNotifications1.Caption := 'E-Mail Notifications';
    SetEvent(EMailNotifications1, Self, 'OnClick', 'EMailNotifications1Click');
    FinancialPeriod.SetParentComponent(btnCompanySettings);
    FinancialPeriod.Name := 'FinancialPeriod';
    FinancialPeriod.Caption := 'Financil Periods';
    SetEvent(FinancialPeriod, Self, 'OnClick', 'FinancialPeriodClick');
    SagePastelExport1.SetParentComponent(btnCompanySettings);
    SagePastelExport1.Name := 'SagePastelExport1';
    SagePastelExport1.Caption := 'Sage Pastel Export';
    SagePastelExport2.SetParentComponent(btnCompanySettings);
    SagePastelExport2.Name := 'SagePastelExport2';
    SagePastelExport2.Caption := 'Sage Pastel Batch Information';
    SubsUserAccess1.SetParentComponent(btnCompanySettings);
    SubsUserAccess1.Name := 'SubsUserAccess1';
    SubsUserAccess1.Caption := 'Subs User Access';
    btnCompanyTransactions.SetParentComponent(btnCompany);
    btnCompanyTransactions.Name := 'btnCompanyTransactions';
    btnCompanyTransactions.Caption := 'Transactions';
    BankReconciliation1.SetParentComponent(btnCompanyTransactions);
    BankReconciliation1.Name := 'BankReconciliation1';
    BankReconciliation1.Caption := 'Bank Reconciliation';
    VehicleAsset1.SetParentComponent(wmSubsMainMenu);
    VehicleAsset1.Name := 'VehicleAsset1';
    VehicleAsset1.Caption := 'Vehicle Asset';
    Settings1.SetParentComponent(VehicleAsset1);
    Settings1.Name := 'Settings1';
    Settings1.Caption := 'Settings';
    Budgets1.SetParentComponent(Settings1);
    Budgets1.Name := 'Budgets1';
    Budgets1.Caption := 'Vehicle Informations';
    SetEvent(Budgets1, Self, 'OnClick', 'Budgets1Click');
    VehicleGroup1.SetParentComponent(Settings1);
    VehicleGroup1.Name := 'VehicleGroup1';
    VehicleGroup1.Caption := 'Vehicle Group';
    VehicleCatagories1.SetParentComponent(Settings1);
    VehicleCatagories1.Name := 'VehicleCatagories1';
    VehicleCatagories1.Caption := 'Vehicle Catagories';
    AxleMassSetup1.SetParentComponent(Settings1);
    AxleMassSetup1.Name := 'AxleMassSetup1';
    AxleMassSetup1.Caption := 'Axle Mass Setup';
    VehicleUnitSetup1.SetParentComponent(Settings1);
    VehicleUnitSetup1.Name := 'VehicleUnitSetup1';
    VehicleUnitSetup1.Caption := 'Vehicle Unit Setup';
    CombinationSetup1.SetParentComponent(Settings1);
    CombinationSetup1.Name := 'CombinationSetup1';
    CombinationSetup1.Caption := 'Combination Setup';
    ransactions1.SetParentComponent(VehicleAsset1);
    ransactions1.Name := 'ransactions1';
    ransactions1.Caption := 'Transactions';
    VehicleServiceHistory1.SetParentComponent(ransactions1);
    VehicleServiceHistory1.Name := 'VehicleServiceHistory1';
    VehicleServiceHistory1.Caption := 'Vehicle Service History';
    VehicleServiceHistory2.SetParentComponent(ransactions1);
    VehicleServiceHistory2.Name := 'VehicleServiceHistory2';
    VehicleServiceHistory2.Caption := 'Vehicle Daily Check List';
    VehicleMovement1.SetParentComponent(ransactions1);
    VehicleMovement1.Name := 'VehicleMovement1';
    VehicleMovement1.Caption := 'Vehicle Movement';
    VehicleMovement2.SetParentComponent(ransactions1);
    VehicleMovement2.Name := 'VehicleMovement2';
    VehicleMovement2.Caption := 'Asset Financil Journal';
    ShiftChange1.SetParentComponent(ransactions1);
    ShiftChange1.Name := 'ShiftChange1';
    ShiftChange1.Caption := 'Shift Change';
    Reports2.SetParentComponent(VehicleAsset1);
    Reports2.Name := 'Reports2';
    Reports2.Caption := 'Reports';
    LicenseCOFPermitExpiryDates1.SetParentComponent(Reports2);
    LicenseCOFPermitExpiryDates1.Name := 'LicenseCOFPermitExpiryDates1';
    LicenseCOFPermitExpiryDates1.Caption := 'License/COF/Permit Expiry Dates';
    LicenseCOFPermitExpiryDates2.SetParentComponent(Reports2);
    LicenseCOFPermitExpiryDates2.Name := 'LicenseCOFPermitExpiryDates2';
    LicenseCOFPermitExpiryDates2.Caption := 'Vehicle Combination';
    DailyCheckList1.SetParentComponent(Reports2);
    DailyCheckList1.Name := 'DailyCheckList1';
    DailyCheckList1.Caption := 'Daily Check List';
    DailyCheckList2.SetParentComponent(Reports2);
    DailyCheckList2.Name := 'DailyCheckList2';
    DailyCheckList2.Caption := 'Maintanance Schedule';
    ExportFleetList1.SetParentComponent(Reports2);
    ExportFleetList1.Name := 'ExportFleetList1';
    ExportFleetList1.Caption := 'Export Fleet List';
    Employees1.SetParentComponent(wmSubsMainMenu);
    Employees1.Name := 'Employees1';
    Employees1.Caption := 'Employees';
    Settings2.SetParentComponent(Employees1);
    Settings2.Name := 'Settings2';
    Settings2.Caption := 'Settings';
    EmployeeInformation1.SetParentComponent(Settings2);
    EmployeeInformation1.Name := 'EmployeeInformation1';
    EmployeeInformation1.Caption := 'Employee Information';
    EmployeeInformation2.SetParentComponent(Settings2);
    EmployeeInformation2.Name := 'EmployeeInformation2';
    EmployeeInformation2.Caption := 'Company site Requirements';
    SetupPublicHoliday1.SetParentComponent(Settings2);
    SetupPublicHoliday1.Name := 'SetupPublicHoliday1';
    SetupPublicHoliday1.Caption := 'Setup Public Holiday';
    SetupYearsweetDays1.SetParentComponent(Settings2);
    SetupYearsweetDays1.Name := 'SetupYearsweetDays1';
    SetupYearsweetDays1.Caption := 'Setup Years Week Days';
    CommisionTotalValueSetup1.SetParentComponent(Settings2);
    CommisionTotalValueSetup1.Name := 'CommisionTotalValueSetup1';
    CommisionTotalValueSetup1.Caption := 'Commision Total Value Setup';
    ransactions2.SetParentComponent(Employees1);
    ransactions2.Name := 'ransactions2';
    ransactions2.Caption := 'Transactions';
    EmployeePlanning1.SetParentComponent(ransactions2);
    EmployeePlanning1.Name := 'EmployeePlanning1';
    EmployeePlanning1.Caption := 'Employee Planning';
    EmployeePlanning2.SetParentComponent(ransactions2);
    EmployeePlanning2.Name := 'EmployeePlanning2';
    EmployeePlanning2.Caption := 'Loading Employee Hours';
    Counselling1.SetParentComponent(ransactions2);
    Counselling1.Name := 'Counselling1';
    Counselling1.Caption := 'Counselling';
    Counselling2.SetParentComponent(ransactions2);
    Counselling2.Name := 'Counselling2';
    Counselling2.Caption := 'Warnings';
    PPEIsue1.SetParentComponent(ransactions2);
    PPEIsue1.Name := 'PPEIsue1';
    PPEIsue1.Caption := 'PPE Isue';
    PPEIsue2.SetParentComponent(ransactions2);
    PPEIsue2.Name := 'PPEIsue2';
    PPEIsue2.Caption := 'Send Commission SMS';
    EmployeeDailyCheckList1.SetParentComponent(ransactions2);
    EmployeeDailyCheckList1.Name := 'EmployeeDailyCheckList1';
    EmployeeDailyCheckList1.Caption := 'Employee Daily Check List';
    ActivityLog1.SetParentComponent(ransactions2);
    ActivityLog1.Name := 'ActivityLog1';
    ActivityLog1.Caption := 'Activity Log';
    ransactions3.SetParentComponent(Employees1);
    ransactions3.Name := 'ransactions3';
    ransactions3.Caption := 'Reports';
    ExpiryDates1.SetParentComponent(ransactions3);
    ExpiryDates1.Name := 'ExpiryDates1';
    ExpiryDates1.Caption := 'Expiry Dates';
    Medical1.SetParentComponent(ExpiryDates1);
    Medical1.Name := 'Medical1';
    Medical1.Caption := 'Medical';
    ExpiryDates2.SetParentComponent(ExpiryDates1);
    ExpiryDates2.Name := 'ExpiryDates2';
    ExpiryDates2.Caption := 'License';
    PDrP1.SetParentComponent(ExpiryDates1);
    PDrP1.Name := 'PDrP1';
    PDrP1.Caption := 'PDrP ';
    PDrP2.SetParentComponent(ExpiryDates1);
    PDrP2.Name := 'PDrP2';
    PDrP2.Caption := 'Passport';
    Workspermit1.SetParentComponent(ExpiryDates1);
    Workspermit1.Name := 'Workspermit1';
    Workspermit1.Caption := 'Workspermit';
    Workspermit2.SetParentComponent(ExpiryDates1);
    Workspermit2.Name := 'Workspermit2';
    Workspermit2.Caption := 'Induction';
    raining1.SetParentComponent(ExpiryDates1);
    raining1.Name := 'raining1';
    raining1.Caption := 'Training';
    raining2.SetParentComponent(ransactions3);
    raining2.Name := 'raining2';
    raining2.Caption := 'Age Management';
    FatiqueManagement1.SetParentComponent(ransactions3);
    FatiqueManagement1.Name := 'FatiqueManagement1';
    FatiqueManagement1.Caption := 'Fatique Management';
    FatiqueManagement2.SetParentComponent(ransactions3);
    FatiqueManagement2.Name := 'FatiqueManagement2';
    FatiqueManagement2.Caption := 'Employee List';
    WarningList1.SetParentComponent(ransactions3);
    WarningList1.Name := 'WarningList1';
    WarningList1.Caption := 'Warning Report';
    CounselingReport1.SetParentComponent(ransactions3);
    CounselingReport1.Name := 'CounselingReport1';
    CounselingReport1.Caption := 'Counseling Report';
    CounselingReport2.SetParentComponent(ransactions3);
    CounselingReport2.Name := 'CounselingReport2';
    CounselingReport2.Caption := 'Planning Schedule';
    CommisionReportTotalValue1.SetParentComponent(ransactions3);
    CommisionReportTotalValue1.Name := 'CommisionReportTotalValue1';
    CommisionReportTotalValue1.Caption := 'Commision Report Total Value';
    CommisionReportTotalValue2.SetParentComponent(ransactions3);
    CommisionReportTotalValue2.Name := 'CommisionReportTotalValue2';
    CommisionReportTotalValue2.Caption := 'Employee PPE Register';
    ActivityReport1.SetParentComponent(ransactions3);
    ActivityReport1.Name := 'ActivityReport1';
    ActivityReport1.Caption := 'Activity Report';
    btnSuppliers.SetParentComponent(wmSubsMainMenu);
    btnSuppliers.Name := 'btnSuppliers';
    btnSuppliers.Caption := 'Suppliers';
    Settings3.SetParentComponent(btnSuppliers);
    Settings3.Name := 'Settings3';
    Settings3.Caption := 'Settings';
    Accounts1.SetParentComponent(Settings3);
    Accounts1.Name := 'Accounts1';
    Accounts1.Caption := 'Accounts';
    btnSupplierSetup.SetParentComponent(btnSuppliers);
    btnSupplierSetup.Name := 'btnSupplierSetup';
    btnSupplierSetup.Caption := 'Transactions';
    btnSubContractorPortal.SetParentComponent(btnSupplierSetup);
    btnSubContractorPortal.Name := 'btnSubContractorPortal';
    btnSubContractorPortal.Caption := 'Sub-Contractor';
    Portal1.SetParentComponent(btnSubContractorPortal);
    Portal1.Name := 'Portal1';
    Portal1.Caption := 'Portal';
    Remittance1.SetParentComponent(btnSubContractorPortal);
    Remittance1.Name := 'Remittance1';
    Remittance1.Caption := 'Remittance';
    Payments1.SetParentComponent(btnSubContractorPortal);
    Payments1.Name := 'Payments1';
    Payments1.Caption := 'Payments';
    Sup1.SetParentComponent(btnSupplierSetup);
    Sup1.Name := 'Sup1';
    Sup1.Caption := 'Remittance';
    Payments2.SetParentComponent(btnSupplierSetup);
    Payments2.Name := 'Payments2';
    Payments2.Caption := 'Allocate Remittance for Payments';
    Payments3.SetParentComponent(btnSupplierSetup);
    Payments3.Name := 'Payments3';
    Payments3.Caption := 'Payments';
    UpfrontDieselReceipt1.SetParentComponent(btnSupplierSetup);
    UpfrontDieselReceipt1.Name := 'UpfrontDieselReceipt1';
    UpfrontDieselReceipt1.Caption := 'Upfront Diesel Receipt';
    UpfrontDieselReceipt2.SetParentComponent(btnSupplierSetup);
    UpfrontDieselReceipt2.Name := 'UpfrontDieselReceipt2';
    UpfrontDieselReceipt2.Caption := 'Upfront Maintenance Receipt';
    WriteOffDifferances1.SetParentComponent(btnSupplierSetup);
    WriteOffDifferances1.Name := 'WriteOffDifferances1';
    WriteOffDifferances1.Caption := 'Write-Off Differences';
    AllocateUnAllocate1.SetParentComponent(btnSupplierSetup);
    AllocateUnAllocate1.Name := 'AllocateUnAllocate1';
    AllocateUnAllocate1.Caption := 'Allocate/ Un-Allocate Payments';
    ReverseReceiptPayments1.SetParentComponent(btnSupplierSetup);
    ReverseReceiptPayments1.Name := 'ReverseReceiptPayments1';
    ReverseReceiptPayments1.Caption := 'Reverse Receipt/Payment';
    ransaction1.SetParentComponent(btnSuppliers);
    ransaction1.Name := 'ransaction1';
    ransaction1.Caption := 'Reports';
    SupplierAgeAnalysis1.SetParentComponent(ransaction1);
    SupplierAgeAnalysis1.Name := 'SupplierAgeAnalysis1';
    SupplierAgeAnalysis1.Caption := 'Age Analysis';
    Remittances1.SetParentComponent(ransaction1);
    Remittances1.Name := 'Remittances1';
    Remittances1.Caption := 'Remittances';
    DetailLedger1.SetParentComponent(ransaction1);
    DetailLedger1.Name := 'DetailLedger1';
    DetailLedger1.Caption := 'Detail Ledger';
    Customers1.SetParentComponent(wmSubsMainMenu);
    Customers1.Name := 'Customers1';
    Customers1.Caption := 'Customers';
    Settings4.SetParentComponent(Customers1);
    Settings4.Name := 'Settings4';
    Settings4.Caption := 'Settings';
    accounts2.SetParentComponent(Settings4);
    accounts2.Name := 'accounts2';
    accounts2.Caption := 'accounts';
    ransactions4.SetParentComponent(Customers1);
    ransactions4.Name := 'ransactions4';
    ransactions4.Caption := 'Transactions';
    CustomerReceipt1.SetParentComponent(ransactions4);
    CustomerReceipt1.Name := 'CustomerReceipt1';
    CustomerReceipt1.Caption := 'Customer Receipt';
    WriteOffDifferences1.SetParentComponent(ransactions4);
    WriteOffDifferences1.Name := 'WriteOffDifferences1';
    WriteOffDifferences1.Caption := 'Write Off Differences';
    WriteOffDifferences2.SetParentComponent(ransactions4);
    WriteOffDifferences2.Name := 'WriteOffDifferences2';
    WriteOffDifferences2.Caption := 'Allocate/Un-Alocate Reiceipt';
    ReversalReceiptPayments1.SetParentComponent(ransactions4);
    ReversalReceiptPayments1.Name := 'ReversalReceiptPayments1';
    ReversalReceiptPayments1.Caption := 'Reversal Receipt/Payments';
    ransactions5.SetParentComponent(Customers1);
    ransactions5.Name := 'ransactions5';
    ransactions5.Caption := 'Reports';
    CustomerAgeAnalysis1.SetParentComponent(ransactions5);
    CustomerAgeAnalysis1.Name := 'CustomerAgeAnalysis1';
    CustomerAgeAnalysis1.Caption := 'Customer Age Analysis';
    CustomerAgeAnalysis2.SetParentComponent(ransactions5);
    CustomerAgeAnalysis2.Name := 'CustomerAgeAnalysis2';
    CustomerAgeAnalysis2.Caption := 'Customer Statements';
    CustomerDetailledger1.SetParentComponent(ransactions5);
    CustomerDetailledger1.Name := 'CustomerDetailledger1';
    CustomerDetailledger1.Caption := 'Customer Detail ledger';
    LoadSystem1.SetParentComponent(wmSubsMainMenu);
    LoadSystem1.Name := 'LoadSystem1';
    LoadSystem1.Caption := 'Load System';
    Settings5.SetParentComponent(LoadSystem1);
    Settings5.Name := 'Settings5';
    Settings5.Caption := 'Settings';
    SetupContracts1.SetParentComponent(Settings5);
    SetupContracts1.Name := 'SetupContracts1';
    SetupContracts1.Caption := 'Setup Contracts';
    Settings6.SetParentComponent(LoadSystem1);
    Settings6.Name := 'Settings6';
    Settings6.Caption := 'Transactions';
    CreateLoadConfirmations1.SetParentComponent(Settings6);
    CreateLoadConfirmations1.Name := 'CreateLoadConfirmations1';
    CreateLoadConfirmations1.Caption := 'Create Load Confirmations';
    CreateLoadConfirmations2.SetParentComponent(Settings6);
    CreateLoadConfirmations2.Name := 'CreateLoadConfirmations2';
    CreateLoadConfirmations2.Caption := 'Create Multi Load Confirmation';
    ripsheetPlanning1.SetParentComponent(Settings6);
    ripsheetPlanning1.Name := 'ripsheetPlanning1';
    ripsheetPlanning1.Caption := 'Tripsheet Planning';
    ripsheetPlanning2.SetParentComponent(Settings6);
    ripsheetPlanning2.Name := 'ripsheetPlanning2';
    ripsheetPlanning2.Caption := 'Create Single Load Invoices';
    CreateMultiLoadinvoices1.SetParentComponent(Settings6);
    CreateMultiLoadinvoices1.Name := 'CreateMultiLoadinvoices1';
    CreateMultiLoadinvoices1.Caption := 'Create Multi Load invoices';
    CreateMultiLoadinvoices2.SetParentComponent(Settings6);
    CreateMultiLoadinvoices2.Name := 'CreateMultiLoadinvoices2';
    CreateMultiLoadinvoices2.Caption := 'create Multi Load Sub Invoices';
    CreateLinkedLoadsInvoices1.SetParentComponent(Settings6);
    CreateLinkedLoadsInvoices1.Name := 'CreateLinkedLoadsInvoices1';
    CreateLinkedLoadsInvoices1.Caption := 'Create Linked Loads Invoices';
    CreateLinkedLoadsInvoices2.SetParentComponent(Settings6);
    CreateLinkedLoadsInvoices2.Name := 'CreateLinkedLoadsInvoices2';
    CreateLinkedLoadsInvoices2.Caption := 'Load Credit Notes';
    LoadDebitNotes1.SetParentComponent(Settings6);
    LoadDebitNotes1.Name := 'LoadDebitNotes1';
    LoadDebitNotes1.Caption := 'Get Loads From Clients';
    ViewSubContractorInvoices1.SetParentComponent(Settings6);
    ViewSubContractorInvoices1.Name := 'ViewSubContractorInvoices1';
    ViewSubContractorInvoices1.Caption := 'View Sub-Contractor Invoices';
    ViewSubContractorInvoices2.SetParentComponent(Settings6);
    ViewSubContractorInvoices2.Name := 'ViewSubContractorInvoices2';
    ViewSubContractorInvoices2.Caption := 'Send Client Invoices';
    BatchProgressInvoices1.SetParentComponent(Settings6);
    BatchProgressInvoices1.Name := 'BatchProgressInvoices1';
    BatchProgressInvoices1.Caption := 'Batch Progress Invoices';
    Reports3.SetParentComponent(LoadSystem1);
    Reports3.Name := 'Reports3';
    Reports3.Caption := 'Reports';
    LoadsReports1.SetParentComponent(Reports3);
    LoadsReports1.Name := 'LoadsReports1';
    LoadsReports1.Caption := 'Loads Reports';
    ProfitLoss1.SetParentComponent(LoadsReports1);
    ProfitLoss1.Name := 'ProfitLoss1';
    ProfitLoss1.Caption := 'Profit Loss';
    Progress1.SetParentComponent(LoadsReports1);
    Progress1.Name := 'Progress1';
    Progress1.Caption := 'Progress';
    Outstanding1.SetParentComponent(LoadsReports1);
    Outstanding1.Name := 'Outstanding1';
    Outstanding1.Caption := 'Outstanding';
    VarrianceControlerProgress1.SetParentComponent(LoadsReports1);
    VarrianceControlerProgress1.Name := 'VarrianceControlerProgress1';
    VarrianceControlerProgress1.Caption := 'Varriance ';
    ControlerProgress1.SetParentComponent(LoadsReports1);
    ControlerProgress1.Name := 'ControlerProgress1';
    ControlerProgress1.Caption := 'Controller Progress';
    IncomeReports1.SetParentComponent(Reports3);
    IncomeReports1.Name := 'IncomeReports1';
    IncomeReports1.Caption := 'Income Reports';
    vsFueloncapturedkms1.SetParentComponent(IncomeReports1);
    vsFueloncapturedkms1.Name := 'vsFueloncapturedkms1';
    vsFueloncapturedkms1.Caption := 'vs Fuel on captured km'#39's';
    vsFeuloncalculatedkms1.SetParentComponent(IncomeReports1);
    vsFeuloncalculatedkms1.Name := 'vsFeuloncalculatedkms1';
    vsFeuloncalculatedkms1.Caption := 'vs Feul on calculated km'#39's';
    vsFeuloncalculatedkms2.SetParentComponent(IncomeReports1);
    vsFeuloncalculatedkms2.Name := 'vsFeuloncalculatedkms2';
    vsFeuloncalculatedkms2.Caption := 'vs Load';
    Driver1.SetParentComponent(IncomeReports1);
    Driver1.Name := 'Driver1';
    Driver1.Caption := 'Driver';
    Driver2.SetParentComponent(IncomeReports1);
    Driver2.Name := 'Driver2';
    Driver2.Caption := 'Vehicle';
    Overloading1.SetParentComponent(Reports3);
    Overloading1.Name := 'Overloading1';
    Overloading1.Caption := 'Overloading';
    Overloading2.SetParentComponent(Reports3);
    Overloading2.Name := 'Overloading2';
    Overloading2.Caption := 'Gross Profit';
    Workingday1.SetParentComponent(Reports3);
    Workingday1.Name := 'Workingday1';
    Workingday1.Caption := 'Working day';
    Workingday2.SetParentComponent(Reports3);
    Workingday2.Name := 'Workingday2';
    Workingday2.Caption := 'Driver tharp';
    Provisions1.SetParentComponent(Reports3);
    Provisions1.Name := 'Provisions1';
    Provisions1.Caption := 'Provisions';
    Provisions2.SetParentComponent(Reports3);
    Provisions2.Name := 'Provisions2';
    Provisions2.Caption := 'Loads export';
    LoadsInfoOver12Months1.SetParentComponent(Reports3);
    LoadsInfoOver12Months1.Name := 'LoadsInfoOver12Months1';
    LoadsInfoOver12Months1.Caption := 'Loads Info Over 12 Months';
    LoadsInfoOver12Months2.SetParentComponent(Reports3);
    LoadsInfoOver12Months2.Name := 'LoadsInfoOver12Months2';
    LoadsInfoOver12Months2.Caption := 'Vehicles/Drivers YTD Performance';
    cancelledLoads1.SetParentComponent(Reports3);
    cancelledLoads1.Name := 'cancelledLoads1';
    cancelledLoads1.Caption := 'cancelled Loads';
    cancelledLoads2.SetParentComponent(Reports3);
    cancelledLoads2.Name := 'cancelledLoads2';
    cancelledLoads2.Caption := 'Invoice Due';
    Planning1.SetParentComponent(LoadSystem1);
    Planning1.Name := 'Planning1';
    Planning1.Caption := 'Planning';
    SubContractorEMails1.SetParentComponent(Planning1);
    SubContractorEMails1.Name := 'SubContractorEMails1';
    SubContractorEMails1.Caption := 'Sub-Contractor E-Mails';
    LoadPlanningSummary.SetParentComponent(Planning1);
    LoadPlanningSummary.Name := 'LoadPlanningSummary';
    LoadPlanningSummary.Caption := 'Load Planning Summary';
    SetEvent(LoadPlanningSummary, Self, 'OnClick', 'LoadPlanningSummaryClick');
    ControllerPlanningProfitLoss1.SetParentComponent(Planning1);
    ControllerPlanningProfitLoss1.Name := 'ControllerPlanningProfitLoss1';
    ControllerPlanningProfitLoss1.Caption := 'Controller Planning Profit/Loss';
    ControllerPlanningProfitLoss2.SetParentComponent(Planning1);
    ControllerPlanningProfitLoss2.Name := 'ControllerPlanningProfitLoss2';
    ControllerPlanningProfitLoss2.Caption := 'Export Planned Loads';
    FleetInformation1.SetParentComponent(LoadSystem1);
    FleetInformation1.Name := 'FleetInformation1';
    FleetInformation1.Caption := 'Fleet Information';
    FleetInformation2.SetParentComponent(FleetInformation1);
    FleetInformation2.Name := 'FleetInformation2';
    FleetInformation2.Caption := 'Fleet Information';
    btnFuelSystem.SetParentComponent(wmSubsMainMenu);
    btnFuelSystem.Name := 'btnFuelSystem';
    btnFuelSystem.Caption := 'Fuel System';
    Setup1.SetParentComponent(btnFuelSystem);
    Setup1.Name := 'Setup1';
    Setup1.Caption := 'Settings';
    Attendants1.SetParentComponent(Setup1);
    Attendants1.Name := 'Attendants1';
    Attendants1.Caption := 'Attendants';
    SetEvent(Attendants1, Self, 'OnClick', 'Attendants1Click');
    Depots1.SetParentComponent(Setup1);
    Depots1.Name := 'Depots1';
    Depots1.Caption := 'Depots';
    SetEvent(Depots1, Self, 'OnClick', 'Depots1Click');
    Attendants2.SetParentComponent(Setup1);
    Attendants2.Name := 'Attendants2';
    Attendants2.Caption := 'Depots Tank Setup';
    FuelPriceIncreaseDecrease1.SetParentComponent(Setup1);
    FuelPriceIncreaseDecrease1.Name := 'FuelPriceIncreaseDecrease1';
    FuelPriceIncreaseDecrease1.Caption := 'Fuel Price Increase/Decrease';
    btnFuelSystemTransactions.SetParentComponent(btnFuelSystem);
    btnFuelSystemTransactions.Name := 'btnFuelSystemTransactions';
    btnFuelSystemTransactions.Caption := 'Transactions';
    DailyControlSheets1.SetParentComponent(btnFuelSystemTransactions);
    DailyControlSheets1.Name := 'DailyControlSheets1';
    DailyControlSheets1.Caption := 'Daily Control Sheets';
    DailyControlSheets2.SetParentComponent(btnFuelSystemTransactions);
    DailyControlSheets2.Name := 'DailyControlSheets2';
    DailyControlSheets2.Caption := 'Fuel Month End';
    BulkPurchaseOrder1.SetParentComponent(btnFuelSystemTransactions);
    BulkPurchaseOrder1.Name := 'BulkPurchaseOrder1';
    BulkPurchaseOrder1.Caption := 'Bulk Purchase Order';
    BulkPurchaseOrder2.SetParentComponent(btnFuelSystemTransactions);
    BulkPurchaseOrder2.Name := 'BulkPurchaseOrder2';
    BulkPurchaseOrder2.Caption := 'Bulk Purchase invoice';
    btnFuelOrders.SetParentComponent(btnFuelSystemTransactions);
    btnFuelOrders.Name := 'btnFuelOrders';
    btnFuelOrders.Caption := 'Fuel Orders';
    SetEvent(btnFuelOrders, Self, 'OnClick', 'btnFuelOrdersClick');
    FuelInvoices1.SetParentComponent(btnFuelSystemTransactions);
    FuelInvoices1.Name := 'FuelInvoices1';
    FuelInvoices1.Caption := 'Fuel Invoices';
    GetDieselOrdersFromSupplier1.SetParentComponent(btnFuelSystemTransactions);
    GetDieselOrdersFromSupplier1.Name := 'GetDieselOrdersFromSupplier1';
    GetDieselOrdersFromSupplier1.Caption := 'Get Diesel Orders From Supplier';
    GetDieselOrdersFromSupplier2.SetParentComponent(btnFuelSystemTransactions);
    GetDieselOrdersFromSupplier2.Name := 'GetDieselOrdersFromSupplier2';
    GetDieselOrdersFromSupplier2.Caption := 'Fuel Credit Notes';
    FeulDebitNotes1.SetParentComponent(btnFuelSystemTransactions);
    FeulDebitNotes1.Name := 'FeulDebitNotes1';
    FeulDebitNotes1.Caption := 'Feul Debit Notes';
    UpdateInvoicedFuelOrders1.SetParentComponent(btnFuelSystemTransactions);
    UpdateInvoicedFuelOrders1.Name := 'UpdateInvoicedFuelOrders1';
    UpdateInvoicedFuelOrders1.Caption := 'Update Invoiced Fuel Orders';
    OwnFleetDieselBulkProcess1.SetParentComponent(btnFuelSystemTransactions);
    OwnFleetDieselBulkProcess1.Name := 'OwnFleetDieselBulkProcess1';
    OwnFleetDieselBulkProcess1.Caption := 'Own Fleet Diesel Bulk Process';
    Reports1.SetParentComponent(btnFuelSystem);
    Reports1.Name := 'Reports1';
    Reports1.Caption := 'Reports';
    CostVsIncomeReports1.SetParentComponent(Reports1);
    CostVsIncomeReports1.Name := 'CostVsIncomeReports1';
    CostVsIncomeReports1.Caption := 'Cost Vs Income Reports';
    DieselDepot1.SetParentComponent(CostVsIncomeReports1);
    DieselDepot1.Name := 'DieselDepot1';
    DieselDepot1.Caption := 'Diesel Depot';
    DieselDepot2.SetParentComponent(CostVsIncomeReports1);
    DieselDepot2.Name := 'DieselDepot2';
    DieselDepot2.Caption := 'Fleet';
    DepotStocklevelreport1.SetParentComponent(Reports1);
    DepotStocklevelreport1.Name := 'DepotStocklevelreport1';
    DepotStocklevelreport1.Caption := 'Depot Stock level report';
    DepotStocklevelreport2.SetParentComponent(Reports1);
    DepotStocklevelreport2.Name := 'DepotStocklevelreport2';
    DepotStocklevelreport2.Caption := 'Diesel Order Report';
    DieselvsKmsreport1.SetParentComponent(Reports1);
    DieselvsKmsreport1.Name := 'DieselvsKmsreport1';
    DieselvsKmsreport1.Caption := 'Diesel vs Km'#39's report';
    DieselvsKmsreport2.SetParentComponent(Reports1);
    DieselvsKmsreport2.Name := 'DieselvsKmsreport2';
    DieselvsKmsreport2.Caption := 'Consumptions reports';
    DriverFeul1.SetParentComponent(DieselvsKmsreport2);
    DriverFeul1.Name := 'DriverFeul1';
    DriverFeul1.Caption := 'Driver Fuel';
    VehicleFuel1.SetParentComponent(DieselvsKmsreport2);
    VehicleFuel1.Name := 'VehicleFuel1';
    VehicleFuel1.Caption := 'Vehicle Fuel';
    DailyControllSheetsReports1.SetParentComponent(Reports1);
    DailyControllSheetsReports1.Name := 'DailyControllSheetsReports1';
    DailyControllSheetsReports1.Caption := 'Daily Controll Sheets Reports';
    FuelManSlipInformation1.SetParentComponent(Reports1);
    FuelManSlipInformation1.Name := 'FuelManSlipInformation1';
    FuelManSlipInformation1.Caption := 'Fuel Man Slip Information';
    FuelManSlipInformation2.SetParentComponent(Reports1);
    FuelManSlipInformation2.Name := 'FuelManSlipInformation2';
    FuelManSlipInformation2.Caption := 'Fuel Man Sales';
    WashbaySystem1.SetParentComponent(wmSubsMainMenu);
    WashbaySystem1.Name := 'WashbaySystem1';
    WashbaySystem1.Caption := 'Washbay System';
    Settings7.SetParentComponent(WashbaySystem1);
    Settings7.Name := 'Settings7';
    Settings7.Caption := 'Settings';
    Washbaydepots1.SetParentComponent(Settings7);
    Washbaydepots1.Name := 'Washbaydepots1';
    Washbaydepots1.Caption := 'Washbay depots';
    ImportSetup1.SetParentComponent(Settings7);
    ImportSetup1.Name := 'ImportSetup1';
    ImportSetup1.Caption := 'Import Setup';
    Settings8.SetParentComponent(WashbaySystem1);
    Settings8.Name := 'Settings8';
    Settings8.Caption := 'Transactions';
    ProcessTransactions1.SetParentComponent(Settings8);
    ProcessTransactions1.Name := 'ProcessTransactions1';
    ProcessTransactions1.Caption := 'Process Transactions';
    ProcessTransactions2.SetParentComponent(Settings8);
    ProcessTransactions2.Name := 'ProcessTransactions2';
    ProcessTransactions2.Caption := 'Credit Note';
    DebitNote1.SetParentComponent(Settings8);
    DebitNote1.Name := 'DebitNote1';
    DebitNote1.Caption := 'Debit Note';
    DebitNote2.SetParentComponent(Settings8);
    DebitNote2.Name := 'DebitNote2';
    DebitNote2.Caption := 'Washbay Import';
    GetWashbayOrderFromSupplier1.SetParentComponent(Settings8);
    GetWashbayOrderFromSupplier1.Name := 'GetWashbayOrderFromSupplier1';
    GetWashbayOrderFromSupplier1.Caption := 'Get Washbay Order From Supplier';
    Reports4.SetParentComponent(WashbaySystem1);
    Reports4.Name := 'Reports4';
    Reports4.Caption := 'Reports';
    Washbayorders1.SetParentComponent(Reports4);
    Washbayorders1.Name := 'Washbayorders1';
    Washbayorders1.Caption := 'Washbay orders';
    Washbayorders2.SetParentComponent(Reports4);
    Washbayorders2.Name := 'Washbayorders2';
    Washbayorders2.Caption := 'Washbay Depot';
    ollSystem1.SetParentComponent(wmSubsMainMenu);
    ollSystem1.Name := 'ollSystem1';
    ollSystem1.Caption := 'Toll System';
    ollSystem2.SetParentComponent(ollSystem1);
    ollSystem2.Name := 'ollSystem2';
    ollSystem2.Caption := 'Transactions';
    ollProcessing1.SetParentComponent(ollSystem2);
    ollProcessing1.Name := 'ollProcessing1';
    ollProcessing1.Caption := 'Toll Processing';
    Reports5.SetParentComponent(ollSystem1);
    Reports5.Name := 'Reports5';
    Reports5.Caption := 'Reports';
    ollsPerVehicle1.SetParentComponent(Reports5);
    ollsPerVehicle1.Name := 'ollsPerVehicle1';
    ollsPerVehicle1.Caption := 'Tolls Per Vehicle';
    ollsPerVehicle2.SetParentComponent(wmSubsMainMenu);
    ollsPerVehicle2.Name := 'ollsPerVehicle2';
    ollsPerVehicle2.Caption := 'Maintenance';
    Settings9.SetParentComponent(ollsPerVehicle2);
    Settings9.Name := 'Settings9';
    Settings9.Caption := 'Settings';
    Warehous1.SetParentComponent(Settings9);
    Warehous1.Name := 'Warehous1';
    Warehous1.Caption := 'Warehous';
    Warehous2.SetParentComponent(Settings9);
    Warehous2.Name := 'Warehous2';
    Warehous2.Caption := 'Warehous locations';
    CostDescription1.SetParentComponent(Settings9);
    CostDescription1.Name := 'CostDescription1';
    CostDescription1.Caption := 'Cost Description';
    CostDescription2.SetParentComponent(Settings9);
    CostDescription2.Name := 'CostDescription2';
    CostDescription2.Caption := 'Categories';
    Waranties1.SetParentComponent(Settings9);
    Waranties1.Name := 'Waranties1';
    Waranties1.Caption := 'Waranties';
    Waranties2.SetParentComponent(Settings9);
    Waranties2.Name := 'Waranties2';
    Waranties2.Caption := 'Stock Information';
    VehicleserviceTypes1.SetParentComponent(Settings9);
    VehicleserviceTypes1.Name := 'VehicleserviceTypes1';
    VehicleserviceTypes1.Caption := 'Vehicle service Types';
    Settings10.SetParentComponent(ollsPerVehicle2);
    Settings10.Name := 'Settings10';
    Settings10.Caption := 'Transactions';
    JobCards1.SetParentComponent(Settings10);
    JobCards1.Name := 'JobCards1';
    JobCards1.Caption := 'Job Cards';
    JobCards2.SetParentComponent(Settings10);
    JobCards2.Name := 'JobCards2';
    JobCards2.Caption := 'Goods Repair Note';
    PurchaseRequest1.SetParentComponent(Settings10);
    PurchaseRequest1.Name := 'PurchaseRequest1';
    PurchaseRequest1.Caption := 'Purchase Request';
    PurchaseRequest2.SetParentComponent(Settings10);
    PurchaseRequest2.Name := 'PurchaseRequest2';
    PurchaseRequest2.Caption := 'Purchase orders';
    PurchaseDelivery1.SetParentComponent(Settings10);
    PurchaseDelivery1.Name := 'PurchaseDelivery1';
    PurchaseDelivery1.Caption := 'Purchase Delivery';
    PurchaseDelivery2.SetParentComponent(Settings10);
    PurchaseDelivery2.Name := 'PurchaseDelivery2';
    PurchaseDelivery2.Caption := 'Supplier Invoice';
    SupplierCreditNotes1.SetParentComponent(Settings10);
    SupplierCreditNotes1.Name := 'SupplierCreditNotes1';
    SupplierCreditNotes1.Caption := 'Supplier Credit Notes';
    SupplierCreditNotes2.SetParentComponent(Settings10);
    SupplierCreditNotes2.Name := 'SupplierCreditNotes2';
    SupplierCreditNotes2.Caption := 'Customer Invoices';
    CustomerCreditNotes1.SetParentComponent(Settings10);
    CustomerCreditNotes1.Name := 'CustomerCreditNotes1';
    CustomerCreditNotes1.Caption := 'Customer Credit Notes';
    CustomerCreditNotes2.SetParentComponent(Settings10);
    CustomerCreditNotes2.Name := 'CustomerCreditNotes2';
    CustomerCreditNotes2.Caption := 'Stock transfers';
    StockTake1.SetParentComponent(Settings10);
    StockTake1.Name := 'StockTake1';
    StockTake1.Caption := 'Stock Take';
    StockTake2.SetParentComponent(Settings10);
    StockTake2.Name := 'StockTake2';
    StockTake2.Caption := 'Re-Print Invoices';
    Customers2.SetParentComponent(StockTake2);
    Customers2.Name := 'Customers2';
    Customers2.Caption := 'Customers';
    Customers3.SetParentComponent(StockTake2);
    Customers3.Name := 'Customers3';
    Customers3.Caption := 'Suppliers';
    RePrintCreditNote1.SetParentComponent(Settings10);
    RePrintCreditNote1.Name := 'RePrintCreditNote1';
    RePrintCreditNote1.Caption := 'Re-Print Credit Note';
    CustomersSuppliers1.SetParentComponent(RePrintCreditNote1);
    CustomersSuppliers1.Name := 'CustomersSuppliers1';
    CustomersSuppliers1.Caption := 'Customers ';
    Supplier1.SetParentComponent(RePrintCreditNote1);
    Supplier1.Name := 'Supplier1';
    Supplier1.Caption := 'Suppliers';
    Reports6.SetParentComponent(ollsPerVehicle2);
    Reports6.Name := 'Reports6';
    Reports6.Caption := 'Reports';
    StockLedger1.SetParentComponent(Reports6);
    StockLedger1.Name := 'StockLedger1';
    StockLedger1.Caption := 'Stock Ledger';
    StockLedger2.SetParentComponent(Reports6);
    StockLedger2.Name := 'StockLedger2';
    StockLedger2.Caption := 'JobCard Reports';
    StockQtyOnHand1.SetParentComponent(Reports6);
    StockQtyOnHand1.Name := 'StockQtyOnHand1';
    StockQtyOnHand1.Caption := 'Stock Qty On Hand';
    StockQtyOnHand2.SetParentComponent(Reports6);
    StockQtyOnHand2.Name := 'StockQtyOnHand2';
    StockQtyOnHand2.Caption := 'Stock Delivery Notes';
    StockGoodsReturnNotes1.SetParentComponent(Reports6);
    StockGoodsReturnNotes1.Name := 'StockGoodsReturnNotes1';
    StockGoodsReturnNotes1.Caption := 'Stock Goods Return Notes';
    StockGoodsReturnNotes2.SetParentComponent(Reports6);
    StockGoodsReturnNotes2.Name := 'StockGoodsReturnNotes2';
    StockGoodsReturnNotes2.Caption := 'Stock Qty On return Notes';
    StockQtyOnBackOrder1.SetParentComponent(Reports6);
    StockQtyOnBackOrder1.Name := 'StockQtyOnBackOrder1';
    StockQtyOnBackOrder1.Caption := 'Stock Qty On Back Order';
    StockQtyOnBackOrder2.SetParentComponent(Reports6);
    StockQtyOnBackOrder2.Name := 'StockQtyOnBackOrder2';
    StockQtyOnBackOrder2.Caption := 'Cost Per Cost Center';
    GeneralLedgerPerCostCenter1.SetParentComponent(Reports6);
    GeneralLedgerPerCostCenter1.Name := 'GeneralLedgerPerCostCenter1';
    GeneralLedgerPerCostCenter1.Caption := 'General Ledger Per Cost Center';
    GeneralLedgerPerCostCenter2.SetParentComponent(Reports6);
    GeneralLedgerPerCostCenter2.Name := 'GeneralLedgerPerCostCenter2';
    GeneralLedgerPerCostCenter2.Caption := 'Jobcard Profit/Loss';
    MiscellaneousTransactions1.SetParentComponent(wmSubsMainMenu);
    MiscellaneousTransactions1.Name := 'MiscellaneousTransactions1';
    MiscellaneousTransactions1.Caption := 'Miscellaneous';
    MiscellaneousTransactions2.SetParentComponent(MiscellaneousTransactions1);
    MiscellaneousTransactions2.Name := 'MiscellaneousTransactions2';
    MiscellaneousTransactions2.Caption := 'transactions';
    MiscellaneousCustomerInvoice1.SetParentComponent(MiscellaneousTransactions2);
    MiscellaneousCustomerInvoice1.Name := 'MiscellaneousCustomerInvoice1';
    MiscellaneousCustomerInvoice1.Caption := 'Customer Invoice';
    CustomerCreditNote1.SetParentComponent(MiscellaneousTransactions2);
    CustomerCreditNote1.Name := 'CustomerCreditNote1';
    CustomerCreditNote1.Caption := 'Customer Credit Note';
    CustomerCreditNote2.SetParentComponent(MiscellaneousTransactions2);
    CustomerCreditNote2.Name := 'CustomerCreditNote2';
    CustomerCreditNote2.Caption := 'Customer Debit Note';
    RePrintCustomerInvoice1.SetParentComponent(MiscellaneousTransactions2);
    RePrintCustomerInvoice1.Name := 'RePrintCustomerInvoice1';
    RePrintCustomerInvoice1.Caption := 'Re-Print Customer Invoice';
    Customer1.SetParentComponent(RePrintCustomerInvoice1);
    Customer1.Name := 'Customer1';
    Customer1.Caption := 'Customer';
    Customer2.SetParentComponent(RePrintCustomerInvoice1);
    Customer2.Name := 'Customer2';
    Customer2.Caption := 'sub-Contractor';
    RePrintCustomerInvoice2.SetParentComponent(MiscellaneousTransactions2);
    RePrintCustomerInvoice2.Name := 'RePrintCustomerInvoice2';
    RePrintCustomerInvoice2.Caption := 'Re-Print Customer Credit Note';
    Customer3.SetParentComponent(RePrintCustomerInvoice2);
    Customer3.Name := 'Customer3';
    Customer3.Caption := 'Customer';
    Customer4.SetParentComponent(RePrintCustomerInvoice2);
    Customer4.Name := 'Customer4';
    Customer4.Caption := 'Sub-Contractor';
    RePrintCustomerDebitNote1.SetParentComponent(MiscellaneousTransactions2);
    RePrintCustomerDebitNote1.Name := 'RePrintCustomerDebitNote1';
    RePrintCustomerDebitNote1.Caption := 'Re-Print Customer Debit Note';
    Customer5.SetParentComponent(RePrintCustomerDebitNote1);
    Customer5.Name := 'Customer5';
    Customer5.Caption := 'Customer ';
    Customer6.SetParentComponent(RePrintCustomerDebitNote1);
    Customer6.Name := 'Customer6';
    Customer6.Caption := 'Sub-Contractor';
    RePrintCustomerDebitNote2.SetParentComponent(MiscellaneousTransactions2);
    RePrintCustomerDebitNote2.Name := 'RePrintCustomerDebitNote2';
    RePrintCustomerDebitNote2.Caption := 'Supplier invoice';
    SupplierDebitNote1.SetParentComponent(MiscellaneousTransactions2);
    SupplierDebitNote1.Name := 'SupplierDebitNote1';
    SupplierDebitNote1.Caption := 'Supplier Credit Note';
    SupplierDebitNote2.SetParentComponent(MiscellaneousTransactions2);
    SupplierDebitNote2.Name := 'SupplierDebitNote2';
    SupplierDebitNote2.Caption := 'Supplier Debit Note';
    ManagementReports1.SetParentComponent(wmSubsMainMenu);
    ManagementReports1.Name := 'ManagementReports1';
    ManagementReports1.Caption := 'Management';
    ManagementReports2.SetParentComponent(ManagementReports1);
    ManagementReports2.Name := 'ManagementReports2';
    ManagementReports2.Caption := 'Reports';
    ransactionJournals1.SetParentComponent(ManagementReports2);
    ransactionJournals1.Name := 'ransactionJournals1';
    ransactionJournals1.Caption := 'Transaction Journals';
    ransactionJournals2.SetParentComponent(ManagementReports2);
    ransactionJournals2.Name := 'ransactionJournals2';
    ransactionJournals2.Caption := 'Vehicle Sales Analysis';
    ProductSalesAnalysis1.SetParentComponent(ManagementReports2);
    ProductSalesAnalysis1.Name := 'ProductSalesAnalysis1';
    ProductSalesAnalysis1.Caption := 'Product Sales Analysis';
    ProductSalesAnalysis2.SetParentComponent(ManagementReports2);
    ProductSalesAnalysis2.Name := 'ProductSalesAnalysis2';
    ProductSalesAnalysis2.Caption := 'Vat reports';
    VehicleCostReports1.SetParentComponent(ManagementReports2);
    VehicleCostReports1.Name := 'VehicleCostReports1';
    VehicleCostReports1.Caption := 'Vehicle Cost Reports';
    VehicleCostReports2.SetParentComponent(ManagementReports2);
    VehicleCostReports2.Name := 'VehicleCostReports2';
    VehicleCostReports2.Caption := 'Assets Balances/Installments';
    N12MonthClientSales1.SetParentComponent(ManagementReports2);
    N12MonthClientSales1.Name := 'N12MonthClientSales1';
    N12MonthClientSales1.Caption := '12 Month Client Sales';
    N12MonthClientSales2.SetParentComponent(ManagementReports2);
    N12MonthClientSales2.Name := 'N12MonthClientSales2';
    N12MonthClientSales2.Caption := 'Export Loads/Diesel Information';
    ExportSubsDieselInformation1.SetParentComponent(ManagementReports2);
    ExportSubsDieselInformation1.Name := 'ExportSubsDieselInformation1';
    ExportSubsDieselInformation1.Caption := 'Export Subs Diesel Information';
    DashBoards1.SetParentComponent(ManagementReports1);
    DashBoards1.Name := 'DashBoards1';
    DashBoards1.Caption := 'Dash Boards';
    Maintenance1.SetParentComponent(DashBoards1);
    Maintenance1.Name := 'Maintenance1';
    Maintenance1.Caption := 'Maintenance';
    SetEvent(Maintenance1, Self, 'OnClick', 'Maintenance1Click');
    Loads1.SetParentComponent(DashBoards1);
    Loads1.Name := 'Loads1';
    Loads1.Caption := 'Loads';
    SetEvent(Loads1, Self, 'OnClick', 'Loads1Click');
    ExportSubsDieselInformation2.SetParentComponent(wmSubsMainMenu);
    ExportSubsDieselInformation2.Name := 'ExportSubsDieselInformation2';
    ExportSubsDieselInformation2.Caption := 'Non-Conformance';
    ransactions6.SetParentComponent(ExportSubsDieselInformation2);
    ransactions6.Name := 'ransactions6';
    ransactions6.Caption := 'Transactions';
    AIRegister1.SetParentComponent(ransactions6);
    AIRegister1.Name := 'AIRegister1';
    AIRegister1.Caption := 'A/I Register';
    ransactions7.SetParentComponent(ExportSubsDieselInformation2);
    ransactions7.Name := 'ransactions7';
    ransactions7.Caption := 'Reports';
    ypes1.SetParentComponent(ransactions7);
    ypes1.Name := 'ypes1';
    ypes1.Caption := 'Types';
    ypes2.SetParentComponent(ransactions7);
    ypes2.Name := 'ypes2';
    ypes2.Caption := 'Cost Per Types';
    DaysSinceLastTypes1.SetParentComponent(ransactions7);
    DaysSinceLastTypes1.Name := 'DaysSinceLastTypes1';
    DaysSinceLastTypes1.Caption := 'Days Since Last Types';
    DaysSinceLastTypes2.SetParentComponent(ransactions7);
    DaysSinceLastTypes2.Name := 'DaysSinceLastTypes2';
    DaysSinceLastTypes2.Caption := 'Causes';
    CostPerCause1.SetParentComponent(ransactions7);
    CostPerCause1.Name := 'CostPerCause1';
    CostPerCause1.Caption := 'Cost Per Cause';
    CostPerCause2.SetParentComponent(ransactions7);
    CostPerCause2.Name := 'CostPerCause2';
    CostPerCause2.Caption := 'Days Since Last Cause ';
    Severity1.SetParentComponent(ransactions7);
    Severity1.Name := 'Severity1';
    Severity1.Caption := 'Severity';
    CostPerSeverity1.SetParentComponent(ransactions7);
    CostPerSeverity1.Name := 'CostPerSeverity1';
    CostPerSeverity1.Caption := 'Cost Per Severity';
    Progressreport1.SetParentComponent(ransactions7);
    Progressreport1.Name := 'Progressreport1';
    Progressreport1.Caption := 'Progress report';
    Progressreport2.SetParentComponent(ransactions7);
    Progressreport2.Name := 'Progressreport2';
    Progressreport2.Caption := 'Review Reports';
    AIReports1.SetParentComponent(ransactions7);
    AIReports1.Name := 'AIReports1';
    AIReports1.Caption := 'A/I Register';
    webconnect.SetParentComponent(Self);
    webconnect.Name := 'webconnect';
    webconnect.Connection := dmData.dbConnect;
    webconnect.Left := 368;
    webconnect.Top := 209;
    qUser.SetParentComponent(Self);
    qUser.Name := 'qUser';
    qUser.Connection := dmData.dbConnect;
    qUser.Left := 368;
    qUser.Top := 297;
  finally
    mdMain.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    wpMain.AfterLoadDFMValues;
    wmSubsMainMenu.AfterLoadDFMValues;
    btnFile.AfterLoadDFMValues;
    btnLogout.AfterLoadDFMValues;
    btnCompany.AfterLoadDFMValues;
    btnCompanySettings.AfterLoadDFMValues;
    Company1.AfterLoadDFMValues;
    btnUserAccess.AfterLoadDFMValues;
    SMSNumbers1.AfterLoadDFMValues;
    SMSNumbers2.AfterLoadDFMValues;
    Costinggroups1.AfterLoadDFMValues;
    Costinggroups2.AfterLoadDFMValues;
    EMailNotifications1.AfterLoadDFMValues;
    FinancialPeriod.AfterLoadDFMValues;
    SagePastelExport1.AfterLoadDFMValues;
    SagePastelExport2.AfterLoadDFMValues;
    SubsUserAccess1.AfterLoadDFMValues;
    btnCompanyTransactions.AfterLoadDFMValues;
    BankReconciliation1.AfterLoadDFMValues;
    VehicleAsset1.AfterLoadDFMValues;
    Settings1.AfterLoadDFMValues;
    Budgets1.AfterLoadDFMValues;
    VehicleGroup1.AfterLoadDFMValues;
    VehicleCatagories1.AfterLoadDFMValues;
    AxleMassSetup1.AfterLoadDFMValues;
    VehicleUnitSetup1.AfterLoadDFMValues;
    CombinationSetup1.AfterLoadDFMValues;
    ransactions1.AfterLoadDFMValues;
    VehicleServiceHistory1.AfterLoadDFMValues;
    VehicleServiceHistory2.AfterLoadDFMValues;
    VehicleMovement1.AfterLoadDFMValues;
    VehicleMovement2.AfterLoadDFMValues;
    ShiftChange1.AfterLoadDFMValues;
    Reports2.AfterLoadDFMValues;
    LicenseCOFPermitExpiryDates1.AfterLoadDFMValues;
    LicenseCOFPermitExpiryDates2.AfterLoadDFMValues;
    DailyCheckList1.AfterLoadDFMValues;
    DailyCheckList2.AfterLoadDFMValues;
    ExportFleetList1.AfterLoadDFMValues;
    Employees1.AfterLoadDFMValues;
    Settings2.AfterLoadDFMValues;
    EmployeeInformation1.AfterLoadDFMValues;
    EmployeeInformation2.AfterLoadDFMValues;
    SetupPublicHoliday1.AfterLoadDFMValues;
    SetupYearsweetDays1.AfterLoadDFMValues;
    CommisionTotalValueSetup1.AfterLoadDFMValues;
    ransactions2.AfterLoadDFMValues;
    EmployeePlanning1.AfterLoadDFMValues;
    EmployeePlanning2.AfterLoadDFMValues;
    Counselling1.AfterLoadDFMValues;
    Counselling2.AfterLoadDFMValues;
    PPEIsue1.AfterLoadDFMValues;
    PPEIsue2.AfterLoadDFMValues;
    EmployeeDailyCheckList1.AfterLoadDFMValues;
    ActivityLog1.AfterLoadDFMValues;
    ransactions3.AfterLoadDFMValues;
    ExpiryDates1.AfterLoadDFMValues;
    Medical1.AfterLoadDFMValues;
    ExpiryDates2.AfterLoadDFMValues;
    PDrP1.AfterLoadDFMValues;
    PDrP2.AfterLoadDFMValues;
    Workspermit1.AfterLoadDFMValues;
    Workspermit2.AfterLoadDFMValues;
    raining1.AfterLoadDFMValues;
    raining2.AfterLoadDFMValues;
    FatiqueManagement1.AfterLoadDFMValues;
    FatiqueManagement2.AfterLoadDFMValues;
    WarningList1.AfterLoadDFMValues;
    CounselingReport1.AfterLoadDFMValues;
    CounselingReport2.AfterLoadDFMValues;
    CommisionReportTotalValue1.AfterLoadDFMValues;
    CommisionReportTotalValue2.AfterLoadDFMValues;
    ActivityReport1.AfterLoadDFMValues;
    btnSuppliers.AfterLoadDFMValues;
    Settings3.AfterLoadDFMValues;
    Accounts1.AfterLoadDFMValues;
    btnSupplierSetup.AfterLoadDFMValues;
    btnSubContractorPortal.AfterLoadDFMValues;
    Portal1.AfterLoadDFMValues;
    Remittance1.AfterLoadDFMValues;
    Payments1.AfterLoadDFMValues;
    Sup1.AfterLoadDFMValues;
    Payments2.AfterLoadDFMValues;
    Payments3.AfterLoadDFMValues;
    UpfrontDieselReceipt1.AfterLoadDFMValues;
    UpfrontDieselReceipt2.AfterLoadDFMValues;
    WriteOffDifferances1.AfterLoadDFMValues;
    AllocateUnAllocate1.AfterLoadDFMValues;
    ReverseReceiptPayments1.AfterLoadDFMValues;
    ransaction1.AfterLoadDFMValues;
    SupplierAgeAnalysis1.AfterLoadDFMValues;
    Remittances1.AfterLoadDFMValues;
    DetailLedger1.AfterLoadDFMValues;
    Customers1.AfterLoadDFMValues;
    Settings4.AfterLoadDFMValues;
    accounts2.AfterLoadDFMValues;
    ransactions4.AfterLoadDFMValues;
    CustomerReceipt1.AfterLoadDFMValues;
    WriteOffDifferences1.AfterLoadDFMValues;
    WriteOffDifferences2.AfterLoadDFMValues;
    ReversalReceiptPayments1.AfterLoadDFMValues;
    ransactions5.AfterLoadDFMValues;
    CustomerAgeAnalysis1.AfterLoadDFMValues;
    CustomerAgeAnalysis2.AfterLoadDFMValues;
    CustomerDetailledger1.AfterLoadDFMValues;
    LoadSystem1.AfterLoadDFMValues;
    Settings5.AfterLoadDFMValues;
    SetupContracts1.AfterLoadDFMValues;
    Settings6.AfterLoadDFMValues;
    CreateLoadConfirmations1.AfterLoadDFMValues;
    CreateLoadConfirmations2.AfterLoadDFMValues;
    ripsheetPlanning1.AfterLoadDFMValues;
    ripsheetPlanning2.AfterLoadDFMValues;
    CreateMultiLoadinvoices1.AfterLoadDFMValues;
    CreateMultiLoadinvoices2.AfterLoadDFMValues;
    CreateLinkedLoadsInvoices1.AfterLoadDFMValues;
    CreateLinkedLoadsInvoices2.AfterLoadDFMValues;
    LoadDebitNotes1.AfterLoadDFMValues;
    ViewSubContractorInvoices1.AfterLoadDFMValues;
    ViewSubContractorInvoices2.AfterLoadDFMValues;
    BatchProgressInvoices1.AfterLoadDFMValues;
    Reports3.AfterLoadDFMValues;
    LoadsReports1.AfterLoadDFMValues;
    ProfitLoss1.AfterLoadDFMValues;
    Progress1.AfterLoadDFMValues;
    Outstanding1.AfterLoadDFMValues;
    VarrianceControlerProgress1.AfterLoadDFMValues;
    ControlerProgress1.AfterLoadDFMValues;
    IncomeReports1.AfterLoadDFMValues;
    vsFueloncapturedkms1.AfterLoadDFMValues;
    vsFeuloncalculatedkms1.AfterLoadDFMValues;
    vsFeuloncalculatedkms2.AfterLoadDFMValues;
    Driver1.AfterLoadDFMValues;
    Driver2.AfterLoadDFMValues;
    Overloading1.AfterLoadDFMValues;
    Overloading2.AfterLoadDFMValues;
    Workingday1.AfterLoadDFMValues;
    Workingday2.AfterLoadDFMValues;
    Provisions1.AfterLoadDFMValues;
    Provisions2.AfterLoadDFMValues;
    LoadsInfoOver12Months1.AfterLoadDFMValues;
    LoadsInfoOver12Months2.AfterLoadDFMValues;
    cancelledLoads1.AfterLoadDFMValues;
    cancelledLoads2.AfterLoadDFMValues;
    Planning1.AfterLoadDFMValues;
    SubContractorEMails1.AfterLoadDFMValues;
    LoadPlanningSummary.AfterLoadDFMValues;
    ControllerPlanningProfitLoss1.AfterLoadDFMValues;
    ControllerPlanningProfitLoss2.AfterLoadDFMValues;
    FleetInformation1.AfterLoadDFMValues;
    FleetInformation2.AfterLoadDFMValues;
    btnFuelSystem.AfterLoadDFMValues;
    Setup1.AfterLoadDFMValues;
    Attendants1.AfterLoadDFMValues;
    Depots1.AfterLoadDFMValues;
    Attendants2.AfterLoadDFMValues;
    FuelPriceIncreaseDecrease1.AfterLoadDFMValues;
    btnFuelSystemTransactions.AfterLoadDFMValues;
    DailyControlSheets1.AfterLoadDFMValues;
    DailyControlSheets2.AfterLoadDFMValues;
    BulkPurchaseOrder1.AfterLoadDFMValues;
    BulkPurchaseOrder2.AfterLoadDFMValues;
    btnFuelOrders.AfterLoadDFMValues;
    FuelInvoices1.AfterLoadDFMValues;
    GetDieselOrdersFromSupplier1.AfterLoadDFMValues;
    GetDieselOrdersFromSupplier2.AfterLoadDFMValues;
    FeulDebitNotes1.AfterLoadDFMValues;
    UpdateInvoicedFuelOrders1.AfterLoadDFMValues;
    OwnFleetDieselBulkProcess1.AfterLoadDFMValues;
    Reports1.AfterLoadDFMValues;
    CostVsIncomeReports1.AfterLoadDFMValues;
    DieselDepot1.AfterLoadDFMValues;
    DieselDepot2.AfterLoadDFMValues;
    DepotStocklevelreport1.AfterLoadDFMValues;
    DepotStocklevelreport2.AfterLoadDFMValues;
    DieselvsKmsreport1.AfterLoadDFMValues;
    DieselvsKmsreport2.AfterLoadDFMValues;
    DriverFeul1.AfterLoadDFMValues;
    VehicleFuel1.AfterLoadDFMValues;
    DailyControllSheetsReports1.AfterLoadDFMValues;
    FuelManSlipInformation1.AfterLoadDFMValues;
    FuelManSlipInformation2.AfterLoadDFMValues;
    WashbaySystem1.AfterLoadDFMValues;
    Settings7.AfterLoadDFMValues;
    Washbaydepots1.AfterLoadDFMValues;
    ImportSetup1.AfterLoadDFMValues;
    Settings8.AfterLoadDFMValues;
    ProcessTransactions1.AfterLoadDFMValues;
    ProcessTransactions2.AfterLoadDFMValues;
    DebitNote1.AfterLoadDFMValues;
    DebitNote2.AfterLoadDFMValues;
    GetWashbayOrderFromSupplier1.AfterLoadDFMValues;
    Reports4.AfterLoadDFMValues;
    Washbayorders1.AfterLoadDFMValues;
    Washbayorders2.AfterLoadDFMValues;
    ollSystem1.AfterLoadDFMValues;
    ollSystem2.AfterLoadDFMValues;
    ollProcessing1.AfterLoadDFMValues;
    Reports5.AfterLoadDFMValues;
    ollsPerVehicle1.AfterLoadDFMValues;
    ollsPerVehicle2.AfterLoadDFMValues;
    Settings9.AfterLoadDFMValues;
    Warehous1.AfterLoadDFMValues;
    Warehous2.AfterLoadDFMValues;
    CostDescription1.AfterLoadDFMValues;
    CostDescription2.AfterLoadDFMValues;
    Waranties1.AfterLoadDFMValues;
    Waranties2.AfterLoadDFMValues;
    VehicleserviceTypes1.AfterLoadDFMValues;
    Settings10.AfterLoadDFMValues;
    JobCards1.AfterLoadDFMValues;
    JobCards2.AfterLoadDFMValues;
    PurchaseRequest1.AfterLoadDFMValues;
    PurchaseRequest2.AfterLoadDFMValues;
    PurchaseDelivery1.AfterLoadDFMValues;
    PurchaseDelivery2.AfterLoadDFMValues;
    SupplierCreditNotes1.AfterLoadDFMValues;
    SupplierCreditNotes2.AfterLoadDFMValues;
    CustomerCreditNotes1.AfterLoadDFMValues;
    CustomerCreditNotes2.AfterLoadDFMValues;
    StockTake1.AfterLoadDFMValues;
    StockTake2.AfterLoadDFMValues;
    Customers2.AfterLoadDFMValues;
    Customers3.AfterLoadDFMValues;
    RePrintCreditNote1.AfterLoadDFMValues;
    CustomersSuppliers1.AfterLoadDFMValues;
    Supplier1.AfterLoadDFMValues;
    Reports6.AfterLoadDFMValues;
    StockLedger1.AfterLoadDFMValues;
    StockLedger2.AfterLoadDFMValues;
    StockQtyOnHand1.AfterLoadDFMValues;
    StockQtyOnHand2.AfterLoadDFMValues;
    StockGoodsReturnNotes1.AfterLoadDFMValues;
    StockGoodsReturnNotes2.AfterLoadDFMValues;
    StockQtyOnBackOrder1.AfterLoadDFMValues;
    StockQtyOnBackOrder2.AfterLoadDFMValues;
    GeneralLedgerPerCostCenter1.AfterLoadDFMValues;
    GeneralLedgerPerCostCenter2.AfterLoadDFMValues;
    MiscellaneousTransactions1.AfterLoadDFMValues;
    MiscellaneousTransactions2.AfterLoadDFMValues;
    MiscellaneousCustomerInvoice1.AfterLoadDFMValues;
    CustomerCreditNote1.AfterLoadDFMValues;
    CustomerCreditNote2.AfterLoadDFMValues;
    RePrintCustomerInvoice1.AfterLoadDFMValues;
    Customer1.AfterLoadDFMValues;
    Customer2.AfterLoadDFMValues;
    RePrintCustomerInvoice2.AfterLoadDFMValues;
    Customer3.AfterLoadDFMValues;
    Customer4.AfterLoadDFMValues;
    RePrintCustomerDebitNote1.AfterLoadDFMValues;
    Customer5.AfterLoadDFMValues;
    Customer6.AfterLoadDFMValues;
    RePrintCustomerDebitNote2.AfterLoadDFMValues;
    SupplierDebitNote1.AfterLoadDFMValues;
    SupplierDebitNote2.AfterLoadDFMValues;
    ManagementReports1.AfterLoadDFMValues;
    ManagementReports2.AfterLoadDFMValues;
    ransactionJournals1.AfterLoadDFMValues;
    ransactionJournals2.AfterLoadDFMValues;
    ProductSalesAnalysis1.AfterLoadDFMValues;
    ProductSalesAnalysis2.AfterLoadDFMValues;
    VehicleCostReports1.AfterLoadDFMValues;
    VehicleCostReports2.AfterLoadDFMValues;
    N12MonthClientSales1.AfterLoadDFMValues;
    N12MonthClientSales2.AfterLoadDFMValues;
    ExportSubsDieselInformation1.AfterLoadDFMValues;
    DashBoards1.AfterLoadDFMValues;
    Maintenance1.AfterLoadDFMValues;
    Loads1.AfterLoadDFMValues;
    ExportSubsDieselInformation2.AfterLoadDFMValues;
    ransactions6.AfterLoadDFMValues;
    AIRegister1.AfterLoadDFMValues;
    ransactions7.AfterLoadDFMValues;
    ypes1.AfterLoadDFMValues;
    ypes2.AfterLoadDFMValues;
    DaysSinceLastTypes1.AfterLoadDFMValues;
    DaysSinceLastTypes2.AfterLoadDFMValues;
    CostPerCause1.AfterLoadDFMValues;
    CostPerCause2.AfterLoadDFMValues;
    Severity1.AfterLoadDFMValues;
    CostPerSeverity1.AfterLoadDFMValues;
    Progressreport1.AfterLoadDFMValues;
    Progressreport2.AfterLoadDFMValues;
    AIReports1.AfterLoadDFMValues;
    webconnect.AfterLoadDFMValues;
    qUser.AfterLoadDFMValues;
  end;
end;

end.
